//-------------------------------------------------without POC---------------------------------------

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './RegLogin.css';
// import logo from "../assets/logo.png";
// import { BsInfoCircle } from "react-icons/bs";
// import InformationModal from '../components/InformationModal';
// import PopupModal from '../components/AgreementModal';

// const CombinedLoginRegister = () => {
//   const [userType, setUserType] = useState('vendor');
//   const [mobileNumber, setMobileNumber] = useState('');
//   const [showOTP, setShowOTP] = useState(false);
//   const [otp, setOtp] = useState(['', '', '', '', '', '']);
//   const [isVerifyEnabled, setIsVerifyEnabled] = useState(false);
//   const [isNewUser, setIsNewUser] = useState(false);
//   const [showRegisterOTP, setShowRegisterOTP] = useState(false);
//   const [registerOTP, setRegisterOTP] = useState(['', '', '', '', '', '']);
//   const [isRegisterVerifyEnabled, setIsRegisterVerifyEnabled] = useState(false);
//   const [isOTPVerified, setIsOTPVerified] = useState(false);
//   const [lenderCity, setLenderCity] = useState('');
//   const [branch, setBranch] = useState('');
//   const [state, setState] = useState('');
//   const [address, setAddress] = useState('');
//   const [email, setEmail] = useState('');
//   const [pocName, setPocName] = useState('');
//   const [managerName, setManagerName] = useState('');
//   const [region, setRegion] = useState('');
//   const [dealerName, setDealerName] = useState('');
//   const [location, setLocation] = useState('');
//   const [gstNumber, setGstNumber] = useState('');
//   const [panNumber, setPanNumber] = useState('');
//   const [vendorEmail, setVendorEmail] = useState('');
//   const [vendorPocName, setVendorPocName] = useState('');
//   const [vendorManagerName, setVendorManagerName] = useState('');
//   const [accountNumber, setAccountNumber] = useState('');
//   const [ifscCode, setIfscCode] = useState('');
//   const [vendorPocNumber, setVendorPocNumber] = useState('');
//   const [vendorPocEmail, setVendorPocEmail] = useState('');
//   const [lenderPocNumber, setLenderPocNumber] = useState('');
//   const [lenderPocEmail, setLenderPocEmail] = useState('');
//   const [lenderGstNumber, setLenderGstNumber] = useState('');
//   const [lenderPanNumber, setLenderPanNumber] = useState('');

//   const [validationErrors, setValidationErrors] = useState({
//     branch: '',
//     region: '',
//     mobileNumber: '',
//     email: '',
//     pocName: '',
//     managerName: '',
//     lenderCity: '',
//     state: '',
//     address: '',
//     dealerName: '',
//     location: '',
//     vendorEmail: '',
//     vendorPocName: '',
//     vendorManagerName: '',
//     gstNumber: '',
//     panNumber: '',
//     accountNumber: '',
//     ifscCode: '',
//     vendorPocNumber: '',
//     vendorPocEmail: '',
//     lenderPocNumber: '',
//     lenderPocEmail: '',
//     lenderGstNumber: '',
//     lenderPanNumber: '',
//   });
//   const [isLogin, setIsLogin] = useState(true);
//   const [step, setStep] = useState(1);
//   const [vendorStep, setVendorStep] = useState(1);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalMessage, setModalMessage] = useState("");
//   const [showAgreementModal, setShowAgreementModal] = useState(false);
//   const [policies, setPolicies] = useState({});
//   const [countdown, setCountdown] = useState(60);
//   const [masterLenders, setMasterLenders] = useState([]);
//   const [selectedMasterLender, setSelectedMasterLender] = useState(null);
//   const [zones, setZones] = useState([]);
//   const [selectedZone, setSelectedZone] = useState(null);
//   const [regions, setRegions] = useState([]);
//   const [selectedRegionId, setSelectedRegionId] = useState(null);
//   const [lenderType, setLenderType] = useState('');

//   const nav = useNavigate();

//   useEffect(() => {
//     const isAuthenticated = Cookies.get('adminAuthStatus') === 'true';
//     if (isAuthenticated) {
//       nav('/dashboard');
//     }
//   }, [nav]);

//   useEffect(() => {
//     if (userType === 'lender') {
//       fetchMasterLenders();
//     }
//   }, [userType]);

//   useEffect(() => {
//     if (selectedMasterLender) {
//       const selectedLender = masterLenders.find(ml => ml.id === selectedMasterLender);
//       console.log("lender type ===>", selectedLender.userType);
//       if (selectedLender) {
//         setLenderType(selectedLender.userType);
//         const zonesData = selectedLender.zones || [];
//         setZones(zonesData);
//       }
//       setSelectedZone(null);
//       setRegions([]);
//       setSelectedRegionId(null);
//     }
//   }, [selectedMasterLender, masterLenders]);

//   useEffect(() => {
//     if (selectedZone) {
//       const zoneData = zones.find(z => z.zoneId === selectedZone);
//       const regionsData = zoneData?.regions || [];
//       setRegions(regionsData);
//       setSelectedRegionId(null);
//     }
//   }, [selectedZone, zones]);

//   const fetchMasterLenders = async () => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/getMasterLendersWithDetails`, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       });
//       const data = await response.json();
//       console.log("master lender data ==>", data);
//       setMasterLenders(data);
//     } catch (error) {
//       console.error('Error fetching master lenders:', error);
//     }
//   };

//   const getApiEndpoint = (endpointType) => {
//     const endpoints = {
//       Lender: {
//         sendOTP: "sendOTPLender",
//         validateOTP: "validateOTPLender",
//         sendRegOTP: "sendRegOTPLender",
//         validateRegOTP: "validateRegOTPLender",
//         register: "registerLender",
//         agreement: "agreementLender"
//       },
//       Private_Lender: {
//         sendOTP: "sendOTPPrivateLender",
//         validateOTP: "validateOTPPrivateLender",
//         sendRegOTP: "sendRegOTPPrivateLender",
//         validateRegOTP: "validateRegOTPPrivateLender",
//         register: "registerLender",
//         agreement: "agreementLender"
//       }
//     };
//     return endpoints[lenderType.replace(" ", "_")]?.[endpointType] || endpoints["Lender"][endpointType];
//   };

//   const handleOtpChange = (index, value) => {
//     if (value.length <= 1 && /^\d*$/.test(value)) {
//       const newOtp = [...otp];
//       newOtp[index] = value;
//       setOtp(newOtp);
//       if (value && index < 5) {
//         document.getElementById(`otp-${index + 1}`).focus();
//       }
//     }
//   };

//   const handleRegisterOtpChange = (index, value) => {
//     if (value.length <= 1 && /^\d*$/.test(value)) {
//       const newOtp = [...registerOTP];
//       newOtp[index] = value;
//       setRegisterOTP(newOtp);
//       if (value && index < 5) {
//         document.getElementById(`register-otp-${index + 1}`).focus();
//       }
//     }
//   };

//   useEffect(() => {
//     const isComplete = otp.every(digit => digit.length === 1);
//     setIsVerifyEnabled(isComplete);
//   }, [otp]);

//   useEffect(() => {
//     const isComplete = registerOTP.every(digit => digit.length === 1);
//     setIsRegisterVerifyEnabled(isComplete);
//   }, [registerOTP]);

//   useEffect(() => {
//     if (showOTP && countdown > 0) {
//       const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
//       return () => clearTimeout(timer);
//     }
//   }, [showOTP, countdown]);

//   const toggleView = () => {
//     setIsLogin(!isLogin);
//     setShowOTP(false);
//     setOtp(['', '', '', '', '', '']);
//     setMobileNumber('');
//     setStep(1);
//     setVendorStep(1);
//     setIsNewUser(false);
//     setShowRegisterOTP(false);
//     setRegisterOTP(['', '', '', '', '', '']);
//     setIsOTPVerified(false);
//     setValidationErrors({
//       branch: '',
//       region: '',
//       mobileNumber: '',
//       email: '',
//       pocName: '',
//       managerName: '',
//       lenderCity: '',
//       state: '',
//       address: '',
//       dealerName: '',
//       location: '',
//       vendorEmail: '',
//       vendorPocName: '',
//       vendorManagerName: '',
//       gstNumber: '',
//       panNumber: '',
//       accountNumber: '',
//       ifscCode: '',
//     });
//   };

//   const userToggle = (type) => {
//     setUserType(type);
//     setShowOTP(false);
//     setMobileNumber('');
//     setCountdown(10);
//   };

//   const validateRequired = (value, fieldName) => {
//     if (!value || value.toString().trim() === '') {
//       return `${fieldName} is required`;
//     }
//     return '';
//   };

//   const validateEmail = (email) => {
//     if (!email || email.trim() === '') {
//       return 'Email is required';
//     }
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
//       return 'Please enter a valid email address';
//     }
//     return '';
//   };

//   const validateMobile = (mobile) => {
//     if (!mobile || mobile.trim() === '') {
//       return 'Mobile number is required';
//     }
//     if (!/^\d{10}$/.test(mobile)) {
//       return 'Mobile number must be 10 digits';
//     }
//     return '';
//   };

//   const validateGST = (gst) => {
//     if (!gst || gst.trim() === '') {
//       return 'GST Number is required';
//     }
//     if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst)) {
//       return 'Please enter a valid GST number';
//     }
//     return '';
//   };

//   const validatePAN = (pan) => {
//     if (!pan || pan.trim() === '') {
//       return 'PAN Number is required';
//     }
//     if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
//       return 'Please enter a valid PAN number';
//     }
//     return '';
//   };

//   const validateIFSC = (ifsc) => {
//     if (!ifsc || ifsc.trim() === '') {
//       return 'IFSC Code is required';
//     }
//     if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc)) {
//       return 'Please enter a valid IFSC code';
//     }
//     return '';
//   };

//   const validateAccountNumber = (accountNumber) => {
//     if (!accountNumber || accountNumber.trim() === '') {
//       return 'Account number is required';
//     }
//     if (!/^\d{9,18}$/.test(accountNumber)) {
//       return 'Account number should be between 9 to 18 digits';
//     }
//     return '';
//   };

//   const handleFieldChange = (setter, fieldName, value, validator) => {
//     setter(value);
//     setValidationErrors({
//       ...validationErrors,
//       [fieldName]: validator(value)
//     });
//   };

//   const validateLenderStep1 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;
//     newErrors.branch = validateRequired(branch, 'Branch');
//     newErrors.region = validateRequired(selectedRegionId, 'Region');
//     isValid = !newErrors.branch && !newErrors.region;
//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   const validateLenderStep2 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;
//     newErrors.mobileNumber = validateMobile(mobileNumber);
//     newErrors.email = validateEmail(email);
//     newErrors.pocName = validateRequired(pocName, 'Point of Contact Name');
//     newErrors.managerName = validateRequired(managerName, 'Manager Name');
//     newErrors.lenderPocNumber = validateMobile(lenderPocNumber);
//     newErrors.lenderPocEmail = validateEmail(lenderPocEmail);
//     isValid = !newErrors.mobileNumber && !newErrors.email && !newErrors.pocName && !newErrors.managerName;
//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   const validateLenderForm = () => {
//     let isValid = true;
//     const newErrors = { ...validationErrors };
//     newErrors.branch = validateRequired(branch, 'Branch');
//     newErrors.region = validateRequired(selectedRegionId, 'Region');
//     newErrors.mobileNumber = validateMobile(mobileNumber);
//     newErrors.email = validateEmail(email);
//     newErrors.pocName = validateRequired(pocName, 'Point of Contact Name');
//     newErrors.managerName = validateRequired(managerName, 'Manager Name');
//     newErrors.lenderCity = validateRequired(lenderCity, 'Bank Location');
//     newErrors.state = validateRequired(state, 'State');
//     newErrors.address = validateRequired(address, 'Address');
//     newErrors.lenderPocNumber = validateMobile(lenderPocNumber);
//     newErrors.lenderPocEmail = validateEmail(lenderPocEmail);
//     newErrors.lenderGstNumber = validateGST(lenderGstNumber);
//     newErrors.lenderPanNumber = validatePAN(lenderPanNumber);
//     setValidationErrors(newErrors);
//     isValid = !Object.values(newErrors).some(error => error !== '');
//     return isValid;
//   };

//   const validateVendorStep1 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;
//     newErrors.dealerName = validateRequired(dealerName, 'Dealer Name');
//     newErrors.mobileNumber = validateMobile(mobileNumber);
//     newErrors.location = validateRequired(location, 'Location');
//     isValid = !newErrors.dealerName && !newErrors.mobileNumber && !newErrors.location;
//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   const validateVendorStep2 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;
//     newErrors.vendorEmail = validateEmail(vendorEmail);
//     newErrors.vendorPocName = validateRequired(vendorPocName, 'Point of Contact Name');
//     newErrors.vendorManagerName = validateRequired(vendorManagerName, 'Manager Name');
//     newErrors.vendorPocNumber = validateMobile(vendorPocNumber);
//     newErrors.vendorPocEmail = validateEmail(vendorPocEmail);
//     isValid = !newErrors.vendorEmail && !newErrors.vendorPocName && !newErrors.vendorManagerName && !newErrors.vendorPocNumber && !newErrors.vendorPocEmail;
//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   const validateVendorForm = () => {
//     let isValid = true;
//     const newErrors = { ...validationErrors };
//     newErrors.dealerName = validateRequired(dealerName, 'Dealer Name');
//     newErrors.mobileNumber = validateMobile(mobileNumber);
//     newErrors.location = validateRequired(location, 'Location');
//     newErrors.vendorEmail = validateEmail(vendorEmail);
//     newErrors.vendorPocName = validateRequired(vendorPocName, 'Point of Contact Name');
//     newErrors.vendorManagerName = validateRequired(vendorManagerName, 'Manager Name');
//     newErrors.gstNumber = validateGST(gstNumber);
//     newErrors.panNumber = validatePAN(panNumber);
//     newErrors.accountNumber = validateAccountNumber(accountNumber);
//     newErrors.ifscCode = validateIFSC(ifscCode);
//     newErrors.vendorPocNumber = validateMobile(vendorPocNumber);
//     newErrors.vendorPocEmail = validateEmail(vendorPocEmail);
//     setValidationErrors(newErrors);
//     isValid = !Object.values(newErrors).some(error => error !== '');
//     return isValid;
//   };

//   const handleSendOtp = async () => {
//     if (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber)) {
//       return;
//     }
//      const apiEndpoint = userType === 'lender' ? getApiEndpoint('sendOTP') : "sendOTPVendor";
//      console.log("user Type =>", userType);
//      console.log("apiEndpoint =>", apiEndpoint);
//      var bodyData = userType === 'lender' ? {
//           masterLenderName: masterLenders.find(item => item.id === selectedMasterLender)?.lenderName,
//           number: mobileNumber,
//           masterLenderId: selectedMasterLender
//         } : {
//           number: mobileNumber,
//           masterLenderId: selectedMasterLender
//         }
//         console.log("body data =>", bodyData);
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           "X-Full-URL": window.location.href,
//         },
//         body: JSON.stringify(bodyData)
//       });
//       const data = await response.json();
//       if (data.success) {
//         setShowOTP(true);
//         setCountdown(60);
//       } else if (data.message && data.message.includes("Active session detected")) {
//         setIsModalOpen(true);
//         setModalMessage("Active session detected. Logging in this tab will terminate your previous session.");
//         setShowOTP(true);
//         setCountdown(60);
//       } else if (data.isNewUser === true) {
//         setIsModalOpen(true);
//         setModalMessage("You are not a registered user under the selected type, please register yourself or select the proper category to continue.");
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error sending OTP: ${error.message}`);
//     }
//   };

//   const handleVerifyOtp = async () => {
//     const isOtpComplete = otp.every(digit => digit.length === 1);
//     if (!isOtpComplete) {
//       return;
//     }
//     const apiEndpoint = userType === 'lender' ? getApiEndpoint('validateOTP') : "validateOTPVendor";
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           "X-Full-URL": window.location.href,
//         },
//         body: JSON.stringify({
//           number: mobileNumber,
//           otp: otp.join(''),
//           masterLenderId: selectedMasterLender
//         }),
//         credentials: 'include',
//       });
//       const data = await response.json();
//       if (data.isValidOTP || data.message === "OTP validated successfully") {
//         nav("/dashboard");
//       } else {
//         setIsModalOpen(true);
//         setModalMessage("Invalid OTP");
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error verifying OTP: ${error.message}`);
//     }
//   };

//   const handleSendRegisterOtp = async () => {
//     if (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber)) {
//       return;
//     }
//     const apiEndpoint = userType === 'lender' ? getApiEndpoint('sendRegOTP') : "sendRegOTPVendor";
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           "X-Full-URL": window.location.href,
//         },
//         body: JSON.stringify({
//           number: mobileNumber,
//           masterLenderId: selectedMasterLender
//         })
//       });
//       const data = await response.json();
//       if (data.success || data.message.includes("OTP sent")) {
//         setShowRegisterOTP(true);
//       } else if (data.message.includes("already")) {
//         setIsModalOpen(true);
//         setModalMessage(data.message);
//       } else {
//         setIsModalOpen(true);
//         setModalMessage("Failed to send OTP");
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error sending OTP: ${error.message}`);
//     }
//   };

//   const handleVerifyRegisterOtp = async () => {
//     const isRegisterOtpComplete = registerOTP.every(digit => digit.length === 1);
//     if (!isRegisterOtpComplete) {
//       return;
//     }
//     const apiEndpoint = userType === 'lender' ? getApiEndpoint('validateRegOTP') : "validateRegOTPVendor";
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           "X-Full-URL": window.location.href,
//         },
//         body: JSON.stringify({
//           number: mobileNumber,
//           otp: registerOTP.join(''),
//           masterLenderId: selectedMasterLender
//         }),
//         credentials: 'include',
//       });
//       const data = await response.json();
//       if (data.isValidOTP || data.message === "OTP validated successfully") {
//         setIsOTPVerified(true);
//         setShowRegisterOTP(false);
//       } else {
//         setIsModalOpen(true);
//         setModalMessage("Invalid OTP");
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error verifying OTP: ${error.message}`);
//     }
//   };

//   const handleLenderRegistration = async (e) => {
//     e.preventDefault();
//     if (!validateLenderForm()) {
//       return;
//     }
//     try {
//       const apiEndpoint = getApiEndpoint('agreement');
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`, {
//         method: 'GET',
//         headers: {
//           "X-Full-URL": window.location.href,
//         }
//       });
//       const data = await response.json();
//       setPolicies(data);
//       setShowAgreementModal(true);
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error fetching agreement: ${error.message}`);
//     }
//   };

//   const handleVendorRegistration = async (e) => {
//     e.preventDefault();
//     if (!validateVendorForm()) {
//       return;
//     }
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/agreementDealer`, {
//         method: 'GET',
//         headers: {
//           "X-Full-URL": window.location.href,
//         }
//       });
//       const data = await response.json();
//       setPolicies(data);
//       setShowAgreementModal(true);
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error fetching agreement: ${error.message}`);
//     }
//   };

//   const handleAgreementAgree = async () => {
//     setShowAgreementModal(false);
//     if (userType === 'lender') {
//       try {
//         const selectedLender = masterLenders.find(ml => ml.id === selectedMasterLender);
//         const apiEndpoint = getApiEndpoint('register');
//         const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             "X-Full-URL": window.location.href,
//           },
//           body: JSON.stringify({
//             number: mobileNumber,
//             lenderName: selectedLender?.lenderName || '',
//             lenderCity,
//             branch,
//             state,
//             isActive: true,
//             isSuspended: false,
//             address,
//             email,
//             POC: pocName,
//             manager: managerName,
//             region,
//             lenderType: lenderType,
//             masterLenderId: selectedMasterLender,
//             regionId: selectedRegionId,
//             point_of_contact_number: lenderPocNumber,
//             point_of_contact_email: lenderPocEmail,
//             GST_no: lenderGstNumber,
//             PAN_no: lenderPanNumber
//           })
//         });
//         const data = await response.json();
//         if (data.success) {
//           setIsModalOpen(true);
//           setModalMessage("Registration Successful! Please login to continue.");
//         }
//       } catch (error) {
//         setIsModalOpen(true);
//         setModalMessage(`Error registering lender: ${error.message}`);
//       }
//     } else {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/registerVendor`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             "X-Full-URL": window.location.href,
//           },
//           body: JSON.stringify({
//             number: mobileNumber,
//             dealerName,
//             GSTNo: gstNumber,
//             PANNo: panNumber,
//             email: vendorEmail,
//             POC: vendorPocName,
//             manager: vendorManagerName,
//             bankAccountNumber: accountNumber,
//             IFSCCode: ifscCode,
//             area: '',
//             city: location,
//             state,
//             country: 'India',
//             point_of_contact_number: vendorPocNumber,
//             point_of_contact_email: vendorPocEmail
//           })
//         });
//         const data = await response.json();
//         if (data.success) {
//           setIsModalOpen(true);
//           setModalMessage("Registration Successful! Please login to continue.");
//         }
//       } catch (error) {
//         setIsModalOpen(true);
//         setModalMessage(`Error registering vendor: ${error.message}`);
//       }
//     }
//   };

//   const handleAgreementCancel = () => {
//     setShowAgreementModal(false);
//   };

//   const nextStep = () => {
//     let isValid = true;
//     if (userType === 'vendor') {
//       if (vendorStep === 1) {
//         isValid = validateVendorStep1();
//       } else if (vendorStep === 2) {
//         isValid = validateVendorStep2();
//       }
//     } else {
//       if (step === 1) {
//         isValid = validateLenderStep1();
//       } else if (step === 2) {
//         isValid = validateLenderStep2();
//       }
//     }
//     if (isValid) {
//       if (userType === 'vendor') {
//         setVendorStep(vendorStep + 1);
//       } else {
//         setStep(step + 1);
//       }
//     }
//   };

//   const prevStep = () => {
//     if (userType === 'vendor') {
//       setVendorStep(vendorStep - 1);
//     } else {
//       setStep(step - 1);
//     }
//   };

//   return (
//     <div className="login-register-container">
//       <div className="row h-100 m-0" style={{ alignItems: "center", backgroundColor: "white" }}>
//         <div className="col-12 col-md-12 form-container py-1">
//           <div className="form-wrapper" style={{ width: "fit-content", boxShadow: "0px 0px 5px rgb(0 0 0 / 7%)", padding: "1.5rem" }}>
//             <div className="logo-container text-center mb-4">
//               <img src={logo} alt="VVendu Technology Solutions Pvt. Ltd." className="img-fluid" style={{ height: "20vh" }} />
//             </div>
//             <div className="user-type-toggle mb-4 d-flex justify-content-center">
//               <div className="btn-group" style={{ width: "80%" }}>
//                 <button
//                   className={`btn ${userType === 'vendor' ? 'btn-danger active' : 'btn-outline-danger'}`}
//                   onClick={() => userToggle('vendor')}
//                   style={{ padding: "auto 10px" }}
//                 >
//                   Dealer
//                 </button>
//                 <span style={{ width: "20px" }}></span>
//                 <button
//                   className={`btn ${userType === 'lender' ? 'btn-danger active' : 'btn-outline-danger'}`}
//                   onClick={() => userToggle('lender')}
//                   style={{ padding: "auto 10px" }}
//                 >
//                   Lender
//                 </button>
//               </div>
//             </div>
//             {userType === 'lender' && (
//               <div className="form-group my-4 mx-auto d-flex justify-content-center align-items-center" style={{ maxWidth: "15vw" }}>
//                 <select
//                   className="form-select"
//                   id="lenderType"
//                   value={selectedMasterLender || ''}
//                   onChange={(e) => setSelectedMasterLender(Number(e.target.value))}
//                   style={{ fontWeight: "bold", textAlign: "center", border: "1.5px solid #ee373b", borderRadius: "6.5px", width: "unset" }}
//                   disabled={!isLogin && isOTPVerified}
//                 >
//                   <option value="">------ Select Lender ------</option>
//                   {masterLenders.map((lender) => (
//                     <option key={lender.id} value={lender.id}>
//                       {lender.lenderName}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}
//             {!isLogin && <div className='d-flex justify-content-center mb-4'>
//               <h3 className='title-info-text' style={{ border: "0px", fontWeight: "bold", marginBottom: "0px" }}>{("Register as ") + (userType === 'vendor' ? "Dealer" : "Lender")}</h3>
//             </div>}
//             {isLogin ? (
//               <div className="login-form">
//                 <div className="form-group mb-4">
//                   <label htmlFor="mobileNumber"><b>Enter Mobile Number</b></label>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="mobileNumber"
//                       style={{width:"100%"}}
//                       placeholder="Enter your Mobile Number"
//                       value={mobileNumber}
//                       disabled={!selectedMasterLender && userType === 'lender'}
//                       onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
//                       maxLength="10"
//                       required
//                     />
//                   </div>
//                 </div>
//                 {showOTP && (
//                   <div className="otp-container mb-4">
//                     <div className='d-flex justify-content-between mb-2'>
//                       <label>OTP</label>
//                       <button
//                         className="btn btn-outline-danger"
//                         style={{ fontSize: "10px", fontWeight: "bold" }}
//                         disabled={countdown !== 0}
//                         onClick={handleSendOtp}
//                       >
//                         Resend OTP {countdown !== 0 ? `00:${countdown < 10 ? '0' + countdown : countdown}` : ""}
//                       </button>
//                     </div>
//                     <div className="d-flex justify-content-between">
//                       {otp.map((digit, index) => (
//                         <input
//                           key={index}
//                           id={`otp-${index}`}
//                           type="text"
//                           className="form-control otp-input"
//                           value={digit}
//                           onChange={(e) => handleOtpChange(index, e.target.value)}
//                           maxLength="1"
//                           required
//                         />
//                       ))}
//                     </div>
//                   </div>
//                 )}
//                 {!showOTP ? (
//                   <button
//                     className="btn btn-danger btn-block w-100"
//                     onClick={handleSendOtp}
//                     disabled={mobileNumber.length !== 10 || (!selectedMasterLender && userType === 'lender')}
//                   >
//                     Send OTP
//                   </button>
//                 ) : (
//                   <button
//                     className="btn btn-danger btn-block w-100"
//                     onClick={handleVerifyOtp}
//                   >
//                     Login
//                   </button>
//                 )}
//                 <p className="mt-3 text-center">
//                   New User? <a href="#" style={{ color: "#ee373b" }} onClick={toggleView}><b>Register</b></a>
//                 </p>
//                 {userType == "lender" && <p className="mt-1 text-center">Want to Onboard? <a style={{ color: "#ee373b" }} href="#" onClick={() => {
//                   nav("/masterLogin")
//                 }}>Onboard</a></p>}
//               </div>
//             ) : (
//               <div className="register-form">
//                 {!isOTPVerified ? (
//                   <div>
//                     {!showRegisterOTP ? (
//                       <div>
//                         <div className="form-group mb-4">
//                           <label htmlFor="mobileNumber"><b>Enter Mobile Number</b></label>
//                           <div className="input-group" style={{ display: "flex", flexDirection: "column" }}>
//                             <input
//                               type="text"
//                               className="form-control"
//                               style={{ border: "1.5px solid #ee373b", width: "100%" }}
//                               id="mobileNumber"
//                               disabled={!selectedMasterLender && userType === 'lender'}
//                               placeholder="Enter your Mobile Number"
//                               value={mobileNumber}
//                               onChange={(e) => {
//                                 const value = e.target.value.replace(/\D/g, '').slice(0, 10);
//                                 setMobileNumber(value);
//                                 if (!isLogin) {
//                                   setValidationErrors({
//                                     ...validationErrors,
//                                     mobileNumber: validateMobile(value)
//                                   });
//                                 }
//                               }}
//                               maxLength="10"
//                               required
//                             />
//                             {!isLogin && validationErrors.mobileNumber && (
//                               <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                 {validationErrors.mobileNumber}
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                         <button
//                           className="btn btn-danger btn-block w-100"
//                           onClick={handleSendRegisterOtp}
//                           disabled={mobileNumber.length !== 10 || !!validationErrors.mobileNumber || (!selectedMasterLender && userType === 'lender')}
//                         >
//                           Send OTP
//                         </button>
//                       </div>
//                     ) : (
//                       <div>
//                         <div className="otp-container mb-4">
//                           <label>OTP</label>
//                           <div className="d-flex justify-content-between">
//                             {registerOTP.map((digit, index) => (
//                               <input
//                                 key={index}
//                                 id={`register-otp-${index}`}
//                                 type="text"
//                                 className="form-control otp-input"
//                                 value={digit}
//                                 onChange={(e) => handleRegisterOtpChange(index, e.target.value)}
//                                 maxLength="1"
//                                 required
//                               />
//                             ))}
//                           </div>
//                         </div>
//                         <button
//                           className="btn btn-danger btn-block w-100"
//                           onClick={handleVerifyRegisterOtp}
//                         >
//                           Verify OTP
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 ) : (
//                   <div>
//                     {userType === 'lender' ? (
//                       <form onSubmit={handleLenderRegistration}>
//                         {step === 1 && (
//                           <div>
//                             <h4 style={{ color: "#ee373b", textDecoration: "underline", fontWeight: "bold" }}>Basic Details</h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="branch">Branch*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="branch"
//                                 placeholder="Enter Branch"
//                                 value={branch}
//                                 onChange={(e) => handleFieldChange(
//                                   setBranch,
//                                   'branch',
//                                   e.target.value,
//                                   (value) => validateRequired(value, 'Branch')
//                                 )}
//                                 required
//                               />
//                               {validationErrors.branch && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.branch}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="zone">Zone*</label>
//                               <select
//                                 className="form-control"
//                                 id="zone"
//                                 value={selectedZone || ''}
//                                 onChange={(e) => setSelectedZone(Number(e.target.value))}
//                                 required
//                               >
//                                 <option value="">Select Zone</option>
//                                 {zones.map((zone) => (
//                                   <option key={zone.zoneId} value={zone.zoneId}>
//                                     {zone.zoneDescription}
//                                   </option>
//                                 ))}
//                               </select>
//                               {validationErrors.region && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.region}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="region">Region*</label>
//                               <select
//                                 className="form-control"
//                                 id="region"
//                                 value={selectedRegionId || ''}
//                                 onChange={(e) => {
//                                   const selectedRegion = regions.find(r => r.regionId === Number(e.target.value));
//                                   setSelectedRegionId(Number(e.target.value));
//                                   setRegion(selectedRegion?.regionDescription || '');
//                                 }}
//                                 disabled={!selectedZone}
//                                 required
//                               >
//                                 <option value="">Select Region</option>
//                                 {regions.map((region) => (
//                                   <option key={region.regionId} value={region.regionId}>
//                                     {region.regionDescription}
//                                   </option>
//                                 ))}
//                               </select>
//                               {validationErrors.region && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.region}
//                                 </div>
//                               )}
//                             </div>
//                             <button type="button" className="btn btn-danger btn-block w-100" onClick={nextStep}>Next</button>
//                           </div>
//                         )}
//                         {step === 2 && (
//                           <div>
//                             <h4 style={{ color: "#ee373b", textDecoration: "underline", fontWeight: "bold" }}>Contact Details</h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="mobileNumber">Mobile Number*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="mobileNumber"
//                                 placeholder="Enter your Mobile Number"
//                                 value={mobileNumber}
//                                 disabled={true}
//                                 onChange={(e) => {
//                                   const value = e.target.value.replace(/\D/g, '').slice(0, 10);
//                                   handleFieldChange(
//                                     setMobileNumber,
//                                     'mobileNumber',
//                                     value,
//                                     validateMobile
//                                   );
//                                 }}
//                                 maxLength="10"
//                                 required
//                               />
//                               {validationErrors.mobileNumber && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.mobileNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="email">Email*</label>
//                               <input
//                                 type="email"
//                                 className="form-control"
//                                 id="email"
//                                 placeholder="Enter Email"
//                                 value={email}
//                                 onChange={(e) => handleFieldChange(
//                                   setEmail,
//                                   'email',
//                                   e.target.value,
//                                   validateEmail
//                                 )}
//                                 required
//                               />
//                               {validationErrors.email && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.email}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="pocName">Point of Contact Name*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="pocName"
//                                 placeholder="Enter Point of Contact Name"
//                                 value={pocName}
//                                 onChange={(e) => handleFieldChange(
//                                   setPocName,
//                                   'pocName',
//                                   e.target.value,
//                                   (value) => validateRequired(value, 'Point of Contact Name')
//                                 )}
//                                 required
//                               />
//                               {validationErrors.pocName && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.pocName}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="managerName">Manager Name*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="managerName"
//                                 placeholder="Enter Manager Name"
//                                 value={managerName}
//                                 onChange={(e) => handleFieldChange(
//                                   setManagerName,
//                                   'managerName',
//                                   e.target.value,
//                                   (value) => validateRequired(value, 'Manager Name')
//                                 )}
//                                 required
//                               />
//                               {validationErrors.managerName && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.managerName}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="lenderPocNumber">Point of Contact Number*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="lenderPocNumber"
//                                 placeholder="Enter Point of Contact Number"
//                                 value={lenderPocNumber}
//                                 onChange={(e) => handleFieldChange(
//                                   setLenderPocNumber,
//                                   'lenderPocNumber',
//                                   e.target.value.replace(/\D/g, '').slice(0, 10),
//                                   validateMobile
//                                 )}
//                                 maxLength="10"
//                                 required
//                               />
//                               {validationErrors.lenderPocNumber && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.lenderPocNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="lenderPocEmail">Point of Contact Email*</label>
//                               <input
//                                 type="email"
//                                 className="form-control"
//                                 id="lenderPocEmail"
//                                 placeholder="Enter Point of Contact Email"
//                                 value={lenderPocEmail}
//                                 onChange={(e) => handleFieldChange(
//                                   setLenderPocEmail,
//                                   'lenderPocEmail',
//                                   e.target.value,
//                                   validateEmail
//                                 )}
//                                 required
//                               />
//                               {validationErrors.lenderPocEmail && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.lenderPocEmail}
//                                 </div>
//                               )}
//                             </div>
//                             <button type="button" className="btn btn-secondary btn-block w-100" onClick={prevStep}>Previous</button>
//                             <button type="button" className="btn btn-danger btn-block w-100" onClick={nextStep}>Next</button>
//                           </div>
//                         )}
//                         {step === 3 && (
//                           <div>
//                             <h4 style={{ color: "#ee373b", textDecoration: "underline", fontWeight: "bold" }}>Location Details</h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="lenderCity">Bank Location*</label>
//                               <select
//                                 className="form-control"
//                                 id="lenderCity"
//                                 value={lenderCity}
//                                 onChange={(e) => handleFieldChange(
//                                   setLenderCity,
//                                   'lenderCity',
//                                   e.target.value,
//                                   (value) => validateRequired(value, 'Bank Location')
//                                 )}
//                                 required
//                               >
//                                 <option value="">Select Bank Location</option>
//                                 {['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad', 'Jaipur', 'Lucknow'].map((city) => (
//                                   <option key={city} value={city}>{city}</option>
//                                 ))}
//                               </select>
//                               {validationErrors.lenderCity && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.lenderCity}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="state">State*</label>
//                               <select
//                                 className="form-control"
//                                 id="state"
//                                 value={state}
//                                 onChange={(e) => handleFieldChange(
//                                   setState,
//                                   'state',
//                                   e.target.value,
//                                   (value) => validateRequired(value, 'State')
//                                 )}
//                                 required
//                               >
//                                 <option value="">Select State</option>
//                                 {['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'].map((stateOption) => (
//                                   <option key={stateOption} value={stateOption}>{stateOption}</option>
//                                 ))}
//                               </select>
//                               {validationErrors.state && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.state}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="address">Address*</label>
//                               <textarea
//                                 className="form-control"
//                                 id="address"
//                                 placeholder="Enter Address"
//                                 value={address}
//                                 onChange={(e) => handleFieldChange(
//                                   setAddress,
//                                   'address',
//                                   e.target.value,
//                                   (value) => validateRequired(value, 'Address')
//                                 )}
//                                 required
//                               />
//                               {validationErrors.address && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.address}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="lenderGstNumber">GST Number*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="lenderGstNumber"
//                                 placeholder="Enter GST Number"
//                                 value={lenderGstNumber}
//                                 onChange={(e) => handleFieldChange(
//                                   setLenderGstNumber,
//                                   'lenderGstNumber',
//                                   e.target.value.toUpperCase(),
//                                   validateGST
//                                 )}
//                                 required
//                               />
//                               {validationErrors.lenderGstNumber && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.lenderGstNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="lenderPanNumber">PAN Number*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="lenderPanNumber"
//                                 placeholder="Enter PAN Number"
//                                 value={lenderPanNumber}
//                                 onChange={(e) => handleFieldChange(
//                                   setLenderPanNumber,
//                                   'lenderPanNumber',
//                                   e.target.value.toUpperCase(),
//                                   validatePAN
//                                 )}
//                                 maxLength="10"
//                                 required
//                               />
//                               {validationErrors.lenderPanNumber && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.lenderPanNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <button type="button" className="btn btn-secondary btn-block w-100" onClick={prevStep}>Previous</button>
//                             <button type="submit" className="btn btn-danger btn-block w-100">Register</button>
//                           </div>
//                         )}
//                       </form>
//                     ) : (
//                       <form onSubmit={handleVendorRegistration}>
//                         {vendorStep === 1 && (
//                           <div>
//                             <h4 style={{ color: "#ee373b", textDecoration: "underline", fontWeight: "bold" }}>Basic Details</h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="dealerName">Dealer Name*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="dealerName"
//                                 placeholder="Enter Dealer Name"
//                                 value={dealerName}
//                                 onChange={(e) => handleFieldChange(
//                                   setDealerName,
//                                   'dealerName',
//                                   e.target.value,
//                                   (value) => validateRequired(value, 'Dealer Name')
//                                 )}
//                                 required
//                               />
//                               {validationErrors.dealerName && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.dealerName}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="mobileNumber">Mobile Number*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="mobileNumber"
//                                 placeholder="Enter your Mobile Number"
//                                 value={mobileNumber}
//                                 disabled={true}
//                                 onChange={(e) => {
//                                   const value = e.target.value.replace(/\D/g, '').slice(0, 10);
//                                   handleFieldChange(
//                                     setMobileNumber,
//                                     'mobileNumber',
//                                     value,
//                                     validateMobile
//                                   );
//                                 }}
//                                 maxLength="10"
//                                 required
//                               />
//                               {validationErrors.mobileNumber && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.mobileNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="location">Location*</label>
//                               <select
//                                 className="form-control"
//                                 id="location"
//                                 value={location}
//                                 onChange={(e) => handleFieldChange(
//                                   setLocation,
//                                   'location',
//                                   e.target.value,
//                                   (value) => validateRequired(value, 'Location')
//                                 )}
//                                 required
//                               >
//                                 <option value="">Select Location</option>
//                                 {['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad', 'Jaipur', 'Lucknow'].map((loc) => (
//                                   <option key={loc} value={loc}>{loc}</option>
//                                 ))}
//                               </select>
//                               {validationErrors.location && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.location}
//                                 </div>
//                               )}
//                             </div>
//                             <button type="button" className="btn btn-danger btn-block w-100" onClick={nextStep}>Next</button>
//                           </div>
//                         )}
//                         {vendorStep === 2 && (
//                           <div>
//                             <h4 style={{ color: "#ee373b", textDecoration: "underline", fontWeight: "bold" }}>Contact Details</h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="vendorEmail">Email ID*</label>
//                               <input
//                                 type="email"
//                                 className="form-control"
//                                 id="vendorEmail"
//                                 placeholder="Enter Email"
//                                 value={vendorEmail}
//                                 onChange={(e) => handleFieldChange(
//                                   setVendorEmail,
//                                   'vendorEmail',
//                                   e.target.value,
//                                   validateEmail
//                                 )}
//                                 required
//                               />
//                               {validationErrors.vendorEmail && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.vendorEmail}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="vendorPocName">Point of Contact Name*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="vendorPocName"
//                                 placeholder="Enter Point of Contact Name"
//                                 value={vendorPocName}
//                                 onChange={(e) => handleFieldChange(
//                                   setVendorPocName,
//                                   'vendorPocName',
//                                   e.target.value,
//                                   (value) => validateRequired(value, 'Point of Contact Name')
//                                 )}
//                                 required
//                               />
//                               {validationErrors.vendorPocName && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.vendorPocName}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="vendorManagerName">Manager Name*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="vendorManagerName"
//                                 placeholder="Enter Manager Name"
//                                 value={vendorManagerName}
//                                 onChange={(e) => handleFieldChange(
//                                   setVendorManagerName,
//                                   'vendorManagerName',
//                                   e.target.value,
//                                   (value) => validateRequired(value, 'Manager Name')
//                                 )}
//                                 required
//                               />
//                               {validationErrors.vendorManagerName && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.vendorManagerName}
//                                 </div>
//                               )}
//                               <div className="form-group mb-3">
//                                 <label htmlFor="vendorPocNumber">Point of Contact Number*</label>
//                                 <input
//                                   type="text"
//                                   className="form-control"
//                                   id="vendorPocNumber"
//                                   placeholder="Enter Point of Contact Number"
//                                   value={vendorPocNumber}
//                                   onChange={(e) => handleFieldChange(
//                                     setVendorPocNumber,
//                                     'vendorPocNumber',
//                                     e.target.value.replace(/\D/g, '').slice(0, 10),
//                                     validateMobile
//                                   )}
//                                   maxLength="10"
//                                   required
//                                 />
//                                 {validationErrors.vendorPocNumber && (
//                                   <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                     {validationErrors.vendorPocNumber}
//                                   </div>
//                                 )}
//                               </div>
//                               <div className="form-group mb-3">
//                                 <label htmlFor="vendorPocEmail">Point of Contact Email*</label>
//                                 <input
//                                   type="email"
//                                   className="form-control"
//                                   id="vendorPocEmail"
//                                   placeholder="Enter Point of Contact Email"
//                                   value={vendorPocEmail}
//                                   onChange={(e) => handleFieldChange(
//                                     setVendorPocEmail,
//                                     'vendorPocEmail',
//                                     e.target.value,
//                                     validateEmail
//                                   )}
//                                   required
//                                 />
//                                 {validationErrors.vendorPocEmail && (
//                                   <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                     {validationErrors.vendorPocEmail}
//                                   </div>
//                                 )}
//                               </div>
//                             </div>
//                             <button type="button" className="btn btn-secondary btn-block w-100" onClick={prevStep}>Previous</button>
//                             <button type="button" className="btn btn-danger btn-block w-100" onClick={nextStep}>Next</button>
//                           </div>
//                         )}
//                         {vendorStep === 3 && (
//                           <div>
//                             <h4 style={{ color: "#ee373b", textDecoration: "underline", fontWeight: "bold" }}>Advanced Details</h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="gstNumber">GST Number*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="gstNumber"
//                                 placeholder="Enter GST Number"
//                                 value={gstNumber}
//                                 onChange={(e) => handleFieldChange(
//                                   setGstNumber,
//                                   'gstNumber',
//                                   e.target.value.toUpperCase(),
//                                   validateGST
//                                 )}
//                                 required
//                               />
//                               {validationErrors.gstNumber && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.gstNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="panNumber">PAN Number*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="panNumber"
//                                 placeholder="Enter PAN Number"
//                                 value={panNumber}
//                                 onChange={(e) => handleFieldChange(
//                                   setPanNumber,
//                                   'panNumber',
//                                   e.target.value.toUpperCase(),
//                                   validatePAN
//                                 )}
//                                 maxLength="10"
//                                 required
//                               />
//                               {validationErrors.panNumber && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.panNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="accountNumber">Bank Account Number*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="accountNumber"
//                                 placeholder="Enter Bank Account Number"
//                                 value={accountNumber}
//                                 onChange={(e) => handleFieldChange(
//                                   setAccountNumber,
//                                   'accountNumber',
//                                   e.target.value.replace(/\D/g, ''),
//                                   validateAccountNumber
//                                 )}
//                                 required
//                               />
//                               {validationErrors.accountNumber && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.accountNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="ifscCode">IFSC Code*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="ifscCode"
//                                 placeholder="Enter IFSC Code"
//                                 value={ifscCode}
//                                 onChange={(e) => handleFieldChange(
//                                   setIfscCode,
//                                   'ifscCode',
//                                   e.target.value.toUpperCase(),
//                                   validateIFSC
//                                 )}
//                                 maxLength="11"
//                                 required
//                               />
//                               {validationErrors.ifscCode && (
//                                 <div className="text-danger mt-1 bg-white" style={{ fontSize: '0.8rem' }}>
//                                   {validationErrors.ifscCode}
//                                 </div>
//                               )}
//                             </div>
//                             <button type="button" className="btn btn-secondary btn-block w-100" onClick={prevStep}>Previous</button>
//                             <button type="submit" className="btn btn-danger btn-block w-100">Register</button>
//                           </div>
//                         )}
//                       </form>
//                     )}
//                   </div>
//                 )}
//                 <p className="mt-3 text-center">
//                   Already have an account? <a href="#" style={{color:"#ee373b"}} onClick={toggleView}>Login</a>
//                 </p>
//                 {userType == 'lender' && <p className="mt-3 text-center">Want to Onboard? <a style={{color:"#ee373b"}} href="#" onClick={() => {
//                   nav("/masterLogin")
//                 }}>Onboard</a></p>}
//               </div>
//             )}
//             <InformationModal
//               isOpen={isModalOpen}
//               onClose={() => {
//                 setIsModalOpen(false);
//                 setModalMessage("");
//                 if (isRegisterVerifyEnabled && isOTPVerified) {
//                   setIsLogin(true);
//                 }
//               }}
//               message={modalMessage}
//             />
//             {showAgreementModal && (
//               <PopupModal
//                 onClose={handleAgreementCancel}
//                 onAgree={handleAgreementAgree}
//                 policies={policies}
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CombinedLoginRegister;

//------------------------------------------with POC-------------------------

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./RegLogin.css";
// import logo from "../assets/logo.png";
// import { BsInfoCircle } from "react-icons/bs";
// import InformationModal from "../components/InformationModal";
// import PopupModal from "../components/AgreementModal";

// const CombinedLoginRegister = () => {
//   const [userType, setUserType] = useState("vendor");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showOTP, setShowOTP] = useState(false);
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const [isVerifyEnabled, setIsVerifyEnabled] = useState(false);
//   const [isNewUser, setIsNewUser] = useState(false);
//   const [showRegisterOTP, setShowRegisterOTP] = useState(false);
//   const [registerOTP, setRegisterOTP] = useState(["", "", "", "", "", ""]);
//   const [isRegisterVerifyEnabled, setIsRegisterVerifyEnabled] = useState(false);
//   const [isOTPVerified, setIsOTPVerified] = useState(false);
//   const [lenderCity, setLenderCity] = useState("");
//   const [branch, setBranch] = useState("");
//   const [state, setState] = useState("");
//   const [address, setAddress] = useState("");
//   const [email, setEmail] = useState("");
//   const [pocName, setPocName] = useState("");
//   const [managerName, setManagerName] = useState("");
//   const [region, setRegion] = useState("");
//   const [dealerName, setDealerName] = useState("");
//   const [location, setLocation] = useState("");
//   const [gstNumber, setGstNumber] = useState("");
//   const [panNumber, setPanNumber] = useState("");
//   const [vendorEmail, setVendorEmail] = useState("");
//   const [vendorPocName, setVendorPocName] = useState("");
//   const [vendorManagerName, setVendorManagerName] = useState("");
//   const [accountNumber, setAccountNumber] = useState("");
//   const [ifscCode, setIfscCode] = useState("");
//   const [vendorPocNumber, setVendorPocNumber] = useState("");
//   const [vendorPocEmail, setVendorPocEmail] = useState("");
//   const [lenderPocNumber, setLenderPocNumber] = useState("");
//   const [lenderPocEmail, setLenderPocEmail] = useState("");
//   const [lenderGstNumber, setLenderGstNumber] = useState("");
//   const [lenderPanNumber, setLenderPanNumber] = useState("");

//   const [validationErrors, setValidationErrors] = useState({
//     branch: "",
//     region: "",
//     mobileNumber: "",
//     email: "",
//     pocName: "",
//     managerName: "",
//     lenderCity: "",
//     state: "",
//     address: "",
//     dealerName: "",
//     location: "",
//     vendorEmail: "",
//     vendorPocName: "",
//     vendorManagerName: "",
//     gstNumber: "",
//     panNumber: "",
//     accountNumber: "",
//     ifscCode: "",
//     vendorPocNumber: "",
//     vendorPocEmail: "",
//     lenderPocNumber: "",
//     lenderPocEmail: "",
//     lenderGstNumber: "",
//     lenderPanNumber: "",
//   });
//   const [isLogin, setIsLogin] = useState(true);
//   const [step, setStep] = useState(1);
//   const [vendorStep, setVendorStep] = useState(1);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalMessage, setModalMessage] = useState("");
//   const [showAgreementModal, setShowAgreementModal] = useState(false);
//   const [policies, setPolicies] = useState({});
//   const [countdown, setCountdown] = useState(60);
//   const [masterLenders, setMasterLenders] = useState([]);
//   const [selectedMasterLender, setSelectedMasterLender] = useState(null);
//   const [zones, setZones] = useState([]);
//   const [selectedZone, setSelectedZone] = useState(null);
//   const [regions, setRegions] = useState([]);
//   const [selectedRegionId, setSelectedRegionId] = useState(null);
//   const [lenderType, setLenderType] = useState("");

//   const nav = useNavigate();

//   useEffect(() => {
//     const isAuthenticated = Cookies.get("adminAuthStatus") === "true";
//     if (isAuthenticated) {
//       nav("/dashboard");
//     }
//   }, [nav]);

//   useEffect(() => {
//     if (userType === "lender") {
//       fetchMasterLenders();
//     }
//   }, [userType]);

//   useEffect(() => {
//     if (selectedMasterLender) {
//       const selectedLender = masterLenders.find(
//         (ml) => ml.id === selectedMasterLender
//       );
//       console.log("lender type ===>", selectedLender.userType);
//       if (selectedLender) {
//         setLenderType(selectedLender.userType);
//         const zonesData = selectedLender.zones || [];
//         setZones(zonesData);
//       }
//       setSelectedZone(null);
//       setRegions([]);
//       setSelectedRegionId(null);
//     }
//   }, [selectedMasterLender, masterLenders]);

//   useEffect(() => {
//     if (selectedZone) {
//       const zoneData = zones.find((z) => z.zoneId === selectedZone);
//       const regionsData = zoneData?.regions || [];
//       setRegions(regionsData);
//       setSelectedRegionId(null);
//     }
//   }, [selectedZone, zones]);

//   const fetchMasterLenders = async () => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/auth/getMasterLendersWithDetails`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       const data = await response.json();
//       console.log("master lender data ==>", data);
//       setMasterLenders(data);
//     } catch (error) {
//       console.error("Error fetching master lenders:", error);
//     }
//   };

//   const getApiEndpoint = (endpointType) => {
//     const endpoints = {
//       Lender: {
//         sendOTP: "sendOTPLender",
//         validateOTP: "validateOTPLender",
//         sendRegOTP: "sendRegOTPLender",
//         validateRegOTP: "validateRegOTPLender",
//         register: "registerLender",
//         agreement: "agreementLender",
//       },
//       Private_Lender: {
//         sendOTP: "sendOTPPrivateLender",
//         validateOTP: "validateOTPPrivateLender",
//         sendRegOTP: "sendRegOTPPrivateLender",
//         validateRegOTP: "validateRegOTPPrivateLender",
//         register: "registerLender",
//         agreement: "agreementLender",
//       },
//     };
//     return (
//       endpoints[lenderType.replace(" ", "_")]?.[endpointType] ||
//       endpoints["Lender"][endpointType]
//     );
//   };

//   const handleOtpChange = (index, value) => {
//     if (value.length <= 1 && /^\d*$/.test(value)) {
//       const newOtp = [...otp];
//       newOtp[index] = value;
//       setOtp(newOtp);
//       if (value && index < 5) {
//         document.getElementById(`otp-${index + 1}`).focus();
//       }
//     }
//   };

//   const handleRegisterOtpChange = (index, value) => {
//     if (value.length <= 1 && /^\d*$/.test(value)) {
//       const newOtp = [...registerOTP];
//       newOtp[index] = value;
//       setRegisterOTP(newOtp);
//       if (value && index < 5) {
//         document.getElementById(`register-otp-${index + 1}`).focus();
//       }
//     }
//   };

//   useEffect(() => {
//     const isComplete = otp.every((digit) => digit.length === 1);
//     setIsVerifyEnabled(isComplete);
//   }, [otp]);

//   useEffect(() => {
//     const isComplete = registerOTP.every((digit) => digit.length === 1);
//     setIsRegisterVerifyEnabled(isComplete);
//   }, [registerOTP]);

//   useEffect(() => {
//     if (showOTP && countdown > 0) {
//       const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
//       return () => clearTimeout(timer);
//     }
//   }, [showOTP, countdown]);

//   const toggleView = () => {
//     setIsLogin(!isLogin);
//     setShowOTP(false);
//     setOtp(["", "", "", "", "", ""]);
//     setMobileNumber("");
//     setStep(1);
//     setVendorStep(1);
//     setIsNewUser(false);
//     setShowRegisterOTP(false);
//     setRegisterOTP(["", "", "", "", "", ""]);
//     setIsOTPVerified(false);
//     setValidationErrors({
//       branch: "",
//       region: "",
//       mobileNumber: "",
//       email: "",
//       pocName: "",
//       managerName: "",
//       lenderCity: "",
//       state: "",
//       address: "",
//       dealerName: "",
//       location: "",
//       vendorEmail: "",
//       vendorPocName: "",
//       vendorManagerName: "",
//       gstNumber: "",
//       panNumber: "",
//       accountNumber: "",
//       ifscCode: "",
//     });
//   };

//   const userToggle = (type) => {
//     setUserType(type);
//     setShowOTP(false);
//     setMobileNumber("");
//     setCountdown(10);
//   };

//   const validateRequired = (value, fieldName) => {
//     if (!value || value.toString().trim() === "") {
//       return `${fieldName} is required`;
//     }
//     return "";
//   };

//   const validateEmail = (email) => {
//     if (!email || email.trim() === "") {
//       return "Email is required";
//     }
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
//       return "Please enter a valid email address";
//     }
//     return "";
//   };

//   const validateMobile = (mobile) => {
//     if (!mobile || mobile.trim() === "") {
//       return "Mobile number is required";
//     }
//     if (!/^\d{10}$/.test(mobile)) {
//       return "Mobile number must be 10 digits";
//     }
//     return "";
//   };

//   const validateGST = (gst) => {
//     if (!gst || gst.trim() === "") {
//       return "GST Number is required";
//     }
//     if (
//       !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst)
//     ) {
//       return "Please enter a valid GST number";
//     }
//     return "";
//   };

//   const validatePAN = (pan) => {
//     if (!pan || pan.trim() === "") {
//       return "PAN Number is required";
//     }
//     if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
//       return "Please enter a valid PAN number";
//     }
//     return "";
//   };

//   const validateIFSC = (ifsc) => {
//     if (!ifsc || ifsc.trim() === "") {
//       return "IFSC Code is required";
//     }
//     if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc)) {
//       return "Please enter a valid IFSC code";
//     }
//     return "";
//   };

//   const validateAccountNumber = (accountNumber) => {
//     if (!accountNumber || accountNumber.trim() === "") {
//       return "Account number is required";
//     }
//     if (!/^\d{9,18}$/.test(accountNumber)) {
//       return "Account number should be between 9 to 18 digits";
//     }
//     return "";
//   };

//   const handleFieldChange = (setter, fieldName, value, validator) => {
//     setter(value);
//     setValidationErrors({
//       ...validationErrors,
//       [fieldName]: validator(value),
//     });
//   };

//   const validateLenderStep1 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;
//     newErrors.branch = validateRequired(branch, "Branch");
//     newErrors.region = validateRequired(selectedRegionId, "Region");
//     isValid = !newErrors.branch && !newErrors.region;
//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   const validateLenderForm = () => {
//     let isValid = true;
//     const newErrors = { ...validationErrors };
//     newErrors.branch = validateRequired(branch, "Branch");
//     newErrors.region = validateRequired(selectedRegionId, "Region");
//     newErrors.mobileNumber = validateMobile(mobileNumber);
//     newErrors.email = validateEmail(email);
//     newErrors.pocName = validateRequired(pocName, "Point of Contact Name");
//     newErrors.managerName = validateRequired(managerName, "Manager Name");
//     newErrors.lenderCity = validateRequired(lenderCity, "Bank Location");
//     newErrors.state = validateRequired(state, "State");
//     newErrors.address = validateRequired(address, "Address");
//     newErrors.lenderPocNumber = validateMobile(lenderPocNumber);
//     newErrors.lenderPocEmail = validateEmail(lenderPocEmail);
//     newErrors.lenderGstNumber = validateGST(lenderGstNumber);
//     newErrors.lenderPanNumber = validatePAN(lenderPanNumber);
//     setValidationErrors(newErrors);
//     isValid = !Object.values(newErrors).some((error) => error !== "");
//     return isValid;
//   };

//   const validateVendorForm = () => {
//     let isValid = true;
//     const newErrors = { ...validationErrors };
//     newErrors.dealerName = validateRequired(dealerName, "Dealer Name");
//     newErrors.mobileNumber = validateMobile(mobileNumber);
//     newErrors.location = validateRequired(location, "Location");
//     newErrors.vendorEmail = validateEmail(vendorEmail);
//     newErrors.vendorPocName = validateRequired(
//       vendorPocName,
//       "Point of Contact Name"
//     );
//     newErrors.vendorManagerName = validateRequired(
//       vendorManagerName,
//       "Manager Name"
//     );
//     newErrors.gstNumber = validateGST(gstNumber);
//     newErrors.panNumber = validatePAN(panNumber);
//     newErrors.accountNumber = validateAccountNumber(accountNumber);
//     newErrors.ifscCode = validateIFSC(ifscCode);
//     newErrors.vendorPocNumber = validateMobile(vendorPocNumber);
//     newErrors.vendorPocEmail = validateEmail(vendorPocEmail);
//     setValidationErrors(newErrors);
//     isValid = !Object.values(newErrors).some((error) => error !== "");
//     return isValid;
//   };

//   const handleSendOtp = async () => {
//     if (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber)) {
//       return;
//     }
//     const apiEndpoint =
//       userType === "lender" ? getApiEndpoint("sendOTP") : "sendOTPVendor";
//     console.log("user Type =>", userType);
//     console.log("apiEndpoint =>", apiEndpoint);
//     var bodyData =
//       userType === "lender"
//         ? {
//             masterLenderName: masterLenders.find(
//               (item) => item.id === selectedMasterLender
//             )?.lenderName,
//             number: mobileNumber,
//             masterLenderId: selectedMasterLender,
//           }
//         : {
//             number: mobileNumber,
//             masterLenderId: selectedMasterLender,
//           };
//     console.log("body data =>", bodyData);
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             "X-Full-URL": window.location.href,
//           },
//           body: JSON.stringify(bodyData),
//         }
//       );
//       const data = await response.json();
//       if (data.success) {
//         setShowOTP(true);
//         setCountdown(60);
//       } else if (
//         data.message &&
//         data.message.includes("Active session detected")
//       ) {
//         setIsModalOpen(true);
//         setModalMessage(
//           "Active session detected. Logging in this tab will terminate your previous session."
//         );
//         setShowOTP(true);
//         setCountdown(60);
//       } else if (data.isNewUser === true) {
//         setIsModalOpen(true);
//         setModalMessage(
//           "You are not a registered user under the selected type, please register yourself or select the proper category to continue."
//         );
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error sending OTP: ${error.message}`);
//     }
//   };

//   const handleVerifyOtp = async () => {
//     const isOtpComplete = otp.every((digit) => digit.length === 1);
//     if (!isOtpComplete) {
//       return;
//     }
//     const apiEndpoint =
//       userType === "lender"
//         ? getApiEndpoint("validateOTP")
//         : "validateOTPVendor";
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             "X-Full-URL": window.location.href,
//           },
//           body: JSON.stringify({
//             number: mobileNumber,
//             otp: otp.join(""),
//             masterLenderId: selectedMasterLender,
//           }),
//           credentials: "include",
//         }
//       );
//       const data = await response.json();
//       if (data.isValidOTP || data.message === "OTP validated successfully") {
//         nav("/dashboard");
//       } else {
//         setIsModalOpen(true);
//         setModalMessage("Invalid OTP");
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error verifying OTP: ${error.message}`);
//     }
//   };

//   const handleSendRegisterOtp = async () => {
//     if (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber)) {
//       return;
//     }
//     const apiEndpoint =
//       userType === "lender" ? getApiEndpoint("sendRegOTP") : "sendRegOTPVendor";
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             "X-Full-URL": window.location.href,
//           },
//           body: JSON.stringify({
//             number: mobileNumber,
//             masterLenderId: selectedMasterLender,
//           }),
//         }
//       );
//       const data = await response.json();
//       if (data.success || data.message.includes("OTP sent")) {
//         setShowRegisterOTP(true);
//       } else if (data.message.includes("already")) {
//         setIsModalOpen(true);
//         setModalMessage(data.message);
//       } else {
//         setIsModalOpen(true);
//         setModalMessage("Failed to send OTP");
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error sending OTP: ${error.message}`);
//     }
//   };

//   const handleVerifyRegisterOtp = async () => {
//     const isRegisterOtpComplete = registerOTP.every(
//       (digit) => digit.length === 1
//     );
//     if (!isRegisterOtpComplete) {
//       return;
//     }
//     const apiEndpoint =
//       userType === "lender"
//         ? getApiEndpoint("validateRegOTP")
//         : "validateRegOTPVendor";
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             "X-Full-URL": window.location.href,
//           },
//           body: JSON.stringify({
//             number: mobileNumber,
//             otp: registerOTP.join(""),
//             masterLenderId: selectedMasterLender,
//           }),
//           credentials: "include",
//         }
//       );
//       const data = await response.json();
//       if (data.isValidOTP || data.message === "OTP validated successfully") {
//         setIsOTPVerified(true);
//         setShowRegisterOTP(false);
//       } else {
//         setIsModalOpen(true);
//         setModalMessage("Invalid OTP");
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error verifying OTP: ${error.message}`);
//     }
//   };

//   const handleLenderRegistration = async (e) => {
//     e.preventDefault();
//     if (!validateLenderForm()) {
//       return;
//     }
//     try {
//       const apiEndpoint = getApiEndpoint("agreement");
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`,
//         {
//           method: "GET",
//           headers: {
//             "X-Full-URL": window.location.href,
//           },
//         }
//       );
//       const data = await response.json();
//       setPolicies(data);
//       setShowAgreementModal(true);
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error fetching agreement: ${error.message}`);
//     }
//   };

//   const handleVendorRegistration = async (e) => {
//     e.preventDefault();
//     if (!validateVendorForm()) {
//       return;
//     }
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/auth/agreementDealer`,
//         {
//           method: "GET",
//           headers: {
//             "X-Full-URL": window.location.href,
//           },
//         }
//       );
//       const data = await response.json();
//       setPolicies(data);
//       setShowAgreementModal(true);
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error fetching agreement: ${error.message}`);
//     }
//   };

//   const handleAgreementAgree = async () => {
//     setShowAgreementModal(false);
//     if (userType === "lender") {
//       try {
//         const selectedLender = masterLenders.find(
//           (ml) => ml.id === selectedMasterLender
//         );
//         const apiEndpoint = getApiEndpoint("register");
//         const response = await fetch(
//           `${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               "X-Full-URL": window.location.href,
//             },
//             body: JSON.stringify({
//               number: mobileNumber,
//               lenderName: selectedLender?.lenderName || "",
//               lenderCity,
//               branch,
//               state,
//               isActive: true,
//               isSuspended: false,
//               address,
//               email,
//               POC: pocName,
//               manager: managerName,
//               region,
//               lenderType: lenderType,
//               masterLenderId: selectedMasterLender,
//               regionId: selectedRegionId,
//               point_of_contact_number: lenderPocNumber,
//               point_of_contact_email: lenderPocEmail,
//               GST_no: lenderGstNumber,
//               PAN_no: lenderPanNumber,
//             }),
//           }
//         );
//         const data = await response.json();
//         if (data.success) {
//           setIsModalOpen(true);
//           setModalMessage("Registration Successful! Please login to continue.");
//         }
//       } catch (error) {
//         setIsModalOpen(true);
//         setModalMessage(`Error registering lender: ${error.message}`);
//       }
//     } else {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_API_ENDPOINT}/api/auth/registerVendor`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               "X-Full-URL": window.location.href,
//             },
//             body: JSON.stringify({
//               number: mobileNumber,
//               dealerName,
//               GSTNo: gstNumber,
//               PANNo: panNumber,
//               email: vendorEmail,
//               POC: vendorPocName,
//               manager: vendorManagerName,
//               bankAccountNumber: accountNumber,
//               IFSCCode: ifscCode,
//               area: "",
//               city: location,
//               state,
//               country: "India",
//               point_of_contact_number: vendorPocNumber,
//               point_of_contact_email: vendorPocEmail,
//             }),
//           }
//         );
//         const data = await response.json();
//         if (data.success) {
//           setIsModalOpen(true);
//           setModalMessage("Registration Successful! Please login to continue.");
//         }
//       } catch (error) {
//         setIsModalOpen(true);
//         setModalMessage(`Error registering vendor: ${error.message}`);
//       }
//     }
//   };

//   const handleAgreementCancel = () => {
//     setShowAgreementModal(false);
//   };

//   const validateLenderStep3 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;
//     newErrors.pocName = validateRequired(pocName, "Point of Contact Name");
//     newErrors.lenderPocNumber = validateMobile(lenderPocNumber);
//     newErrors.lenderPocEmail = validateEmail(lenderPocEmail);
//     isValid =
//       !newErrors.pocName &&
//       !newErrors.lenderPocNumber &&
//       !newErrors.lenderPocEmail;
//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   const validateLenderStep4 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;
//     newErrors.lenderCity = validateRequired(lenderCity, "Bank Location");
//     newErrors.state = validateRequired(state, "State");
//     newErrors.address = validateRequired(address, "Address");
//     isValid = !newErrors.lenderCity && !newErrors.state && !newErrors.address;
//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   const validateLenderStep5 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;
//     newErrors.lenderGstNumber = validateGST(lenderGstNumber);
//     newErrors.lenderPanNumber = validatePAN(lenderPanNumber);
//     isValid = !newErrors.lenderGstNumber && !newErrors.lenderPanNumber;
//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   // Update the existing lender step 2 validation
//   const validateLenderStep2 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;
//     newErrors.email = validateEmail(email);
//     newErrors.managerName = validateRequired(managerName, "Manager Name");
//     isValid = !newErrors.email && !newErrors.managerName;
//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   // Update the dealer validation functions
//   const validateVendorStep1 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;
//     newErrors.dealerName = validateRequired(dealerName, "Dealer Name");
//     newErrors.location = validateRequired(location, "Location");
//     newErrors.vendorManagerName = validateRequired(
//       vendorManagerName,
//       "Manager Name"
//     );
//     isValid =
//       !newErrors.dealerName &&
//       !newErrors.location &&
//       !newErrors.vendorManagerName;
//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   // Validation function for Vendor Step 2
//   const validateVendorStep2 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;

//     // Validate Email
//     newErrors.vendorEmail = validateEmail(vendorEmail);
//     if (newErrors.vendorEmail) isValid = false;

//     // Validate Point of Contact Name
//     newErrors.vendorPocName = validateRequired(
//       vendorPocName,
//       "Point of Contact Name"
//     );
//     if (newErrors.vendorPocName) isValid = false;

//     // Validate Point of Contact Number
//     newErrors.vendorPocNumber = validateMobile(vendorPocNumber);
//     if (newErrors.vendorPocNumber) isValid = false;

//     // Validate Point of Contact Email
//     newErrors.vendorPocEmail = validateEmail(vendorPocEmail);
//     if (newErrors.vendorPocEmail) isValid = false;

//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   // Validation function for Vendor Step 3
//   const validateVendorStep3 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;

//     // Validate GST Number
//     newErrors.gstNumber = validateGST(gstNumber);
//     if (newErrors.gstNumber) isValid = false;

//     // Validate PAN Number
//     newErrors.panNumber = validatePAN(panNumber);
//     if (newErrors.panNumber) isValid = false;

//     // Validate Bank Account Number
//     newErrors.accountNumber = validateAccountNumber(accountNumber);
//     if (newErrors.accountNumber) isValid = false;

//     // Validate IFSC Code
//     newErrors.ifscCode = validateIFSC(ifscCode);
//     if (newErrors.ifscCode) isValid = false;

//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   // Update the nextStep and prevStep functions to handle the new step structures
//   const nextStep = () => {
//     let isValid = true;
//     if (userType === "vendor") {
//       if (vendorStep === 1) {
//         isValid = validateVendorStep1();
//       } else if (vendorStep === 2) {
//         isValid = validateVendorStep2();
//       }
//       if (isValid) {
//         setVendorStep(vendorStep + 1);
//       }
//     } else {
//       if (step === 1) {
//         isValid = validateLenderStep1();
//       } else if (step === 2) {
//         isValid = validateLenderStep2();
//       } else if (step === 3) {
//         isValid = validateLenderStep3();
//       } else if (step === 4) {
//         isValid = validateLenderStep4();
//       }
//       if (isValid) {
//         setStep(step + 1);
//       }
//     }
//   };

//   const prevStep = () => {
//     if (userType === "vendor") {
//       if (vendorStep > 1) {
//         setVendorStep(vendorStep - 1);
//       }
//     } else {
//       if (step > 1) {
//         setStep(step - 1);
//       }
//     }
//   };

//   return (
//     <div className="login-register-container">
//       <div
//         className="row h-100 m-0"
//         style={{ alignItems: "center", backgroundColor: "white" }}
//       >
//         <div className="col-12 col-md-12 form-container py-1">
//           <div
//             className="form-wrapper"
//             style={{
//               width: "fit-content",
//               boxShadow: "0px 0px 5px rgb(0 0 0 / 7%)",
//               padding: "1.5rem",
//             }}
//           >
//             <div className="logo-container text-center mb-4">
//               <img
//                 src={logo}
//                 alt="VVendu Technology Solutions Pvt. Ltd."
//                 className="img-fluid"
//                 style={{ height: "15vh" }}
//               />
//             </div>
//             <div className="user-type-toggle mb-4 d-flex justify-content-center">
//               <div className="btn-group" style={{ width: "80%" }}>
//                 <button
//                   className={`btn ${
//                     userType === "vendor"
//                       ? "btn-danger active"
//                       : "btn-outline-danger"
//                   }`}
//                   onClick={() => userToggle("vendor")}
//                   style={{ padding: "auto 10px" }}
//                 >
//                   Dealer
//                 </button>
//                 <span style={{ width: "20px" }}></span>
//                 <button
//                   className={`btn ${
//                     userType === "lender"
//                       ? "btn-danger active"
//                       : "btn-outline-danger"
//                   }`}
//                   onClick={() => userToggle("lender")}
//                   style={{ padding: "auto 10px" }}
//                 >
//                   Lender
//                 </button>
//               </div>
//             </div>
//             {userType === "lender" && !isOTPVerified && (
//               <div
//                 className="form-group my-4 mx-auto d-flex justify-content-center align-items-center"
//                 style={{ maxWidth: "15vw" }}
//               >
//                 <select
//                   className="form-select"
//                   id="lenderType"
//                   value={selectedMasterLender || ""}
//                   onChange={(e) =>
//                     setSelectedMasterLender(Number(e.target.value))
//                   }
//                   style={{
//                     fontWeight: "bold",
//                     textAlign: "center",
//                     border: "1.5px solid #ee373b",
//                     borderRadius: "6.5px",
//                     width: "unset",
//                   }}
//                   disabled={!isLogin && isOTPVerified}
//                 >
//                   <option value="">------ Select Lender ------</option>
//                   {masterLenders.map((lender) => (
//                     <option key={lender.id} value={lender.id}>
//                       {lender.lenderName}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}
//             {!isLogin && (
//               <div className="d-flex justify-content-center mb-4">
//                 <h4
//                   className="title-info-text"
//                   style={{
//                     border: "0px",
//                     fontWeight: "bold",
//                     marginBottom: "0px",
//                     color: "#ee373b"
//                   }}
//                 >
//                   {"Register as " +
//                     (userType === "vendor" ? "Dealer" : "Lender")}
//                 </h4>
//               </div>
//             )}
//             {isLogin ? (
//               <div className="login-form">
//                 <div className="form-group mb-4">
//                   <label htmlFor="mobileNumber">
//                     <b>Enter Mobile Number</b>
//                   </label>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="mobileNumber"
//                       style={{ width: "100%" }}
//                       placeholder="Enter your Mobile Number"
//                       value={mobileNumber}
//                       disabled={!selectedMasterLender && userType === "lender"}
//                       onChange={(e) =>
//                         setMobileNumber(
//                           e.target.value.replace(/\D/g, "").slice(0, 10)
//                         )
//                       }
//                       maxLength="10"
//                       required
//                     />
//                   </div>
//                 </div>
//                 {showOTP && (
//                   <div className="otp-container mb-4">
//                     <div className="d-flex justify-content-between mb-2">
//                       <label>OTP</label>
//                       <button
//                         className="btn btn-outline-danger"
//                         style={{ fontSize: "10px", fontWeight: "bold" }}
//                         disabled={countdown !== 0}
//                         onClick={handleSendOtp}
//                       >
//                         Resend OTP{" "}
//                         {countdown !== 0
//                           ? `00:${countdown < 10 ? "0" + countdown : countdown}`
//                           : ""}
//                       </button>
//                     </div>
//                     <div className="d-flex justify-content-between">
//                       {otp.map((digit, index) => (
//                         <input
//                           key={index}
//                           id={`otp-${index}`}
//                           type="text"
//                           className="form-control otp-input"
//                           value={digit}
//                           onChange={(e) =>
//                             handleOtpChange(index, e.target.value)
//                           }
//                           maxLength="1"
//                           required
//                         />
//                       ))}
//                     </div>
//                   </div>
//                 )}
//                 {!showOTP ? (
//                   <button
//                     className="btn btn-danger btn-block w-100"
//                     onClick={handleSendOtp}
//                     disabled={
//                       mobileNumber.length !== 10 ||
//                       (!selectedMasterLender && userType === "lender")
//                     }
//                   >
//                     Send OTP
//                   </button>
//                 ) : (
//                   <button
//                     className="btn btn-danger btn-block w-100"
//                     onClick={handleVerifyOtp}
//                   >
//                     Login
//                   </button>
//                 )}
//                 <p className="mt-3 text-center">
//                   New User?{" "}
//                   <a href="#" style={{ color: "#ee373b" }} onClick={toggleView}>
//                     <b>Register</b>
//                   </a>
//                 </p>
//                 {userType == "lender" && (
//                   <p className="mt-1 text-center">
//                     Want to Onboard?{" "}
//                     <a
//                       style={{ color: "#ee373b" }}
//                       href="#"
//                       onClick={() => {
//                         nav("/masterLogin");
//                       }}
//                     >
//                       Onboard
//                     </a>
//                   </p>
//                 )}
//               </div>
//             ) : (
//               <div className="register-form">
//                 {!isOTPVerified ? (
//                   <div>
//                     {!showRegisterOTP ? (
//                       <div>
//                         <div className="form-group mb-4">
//                           <label htmlFor="mobileNumber">
//                             <b>Enter Mobile Number</b>
//                           </label>
//                           <div
//                             className="input-group"
//                             style={{ display: "flex", flexDirection: "column" }}
//                           >
//                             <input
//                               type="text"
//                               className="form-control"
//                               style={{
//                                 border: "1.5px solid #ee373b",
//                                 width: "100%",
//                               }}
//                               id="mobileNumber"
//                               disabled={
//                                 !selectedMasterLender && userType === "lender"
//                               }
//                               placeholder="Enter your Mobile Number"
//                               value={mobileNumber}
//                               onChange={(e) => {
//                                 const value = e.target.value
//                                   .replace(/\D/g, "")
//                                   .slice(0, 10);
//                                 setMobileNumber(value);
//                                 if (!isLogin) {
//                                   setValidationErrors({
//                                     ...validationErrors,
//                                     mobileNumber: validateMobile(value),
//                                   });
//                                 }
//                               }}
//                               maxLength="10"
//                               required
//                             />
//                             {!isLogin && validationErrors.mobileNumber && (
//                               <div
//                                 className="text-danger mt-1 bg-white"
//                                 style={{ fontSize: "0.8rem" }}
//                               >
//                                 {validationErrors.mobileNumber}
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                         <button
//                           className="btn btn-danger btn-block w-100"
//                           onClick={handleSendRegisterOtp}
//                           disabled={
//                             mobileNumber.length !== 10 ||
//                             !!validationErrors.mobileNumber ||
//                             (!selectedMasterLender && userType === "lender")
//                           }
//                         >
//                           Send OTP
//                         </button>
//                       </div>
//                     ) : (
//                       <div>
//                         <div className="otp-container mb-4">
//                           <label>OTP</label>
//                           <div className="d-flex justify-content-between">
//                             {registerOTP.map((digit, index) => (
//                               <input
//                                 key={index}
//                                 id={`register-otp-${index}`}
//                                 type="text"
//                                 className="form-control otp-input"
//                                 value={digit}
//                                 onChange={(e) =>
//                                   handleRegisterOtpChange(index, e.target.value)
//                                 }
//                                 maxLength="1"
//                                 required
//                               />
//                             ))}
//                           </div>
//                         </div>
//                         <button
//                           className="btn btn-danger btn-block w-100"
//                           onClick={handleVerifyRegisterOtp}
//                         >
//                           Verify OTP
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 ) : (
//                   <div>
//                     {userType === "lender" ? (
//                       <form onSubmit={handleLenderRegistration}>
//                         {step === 1 && (
//                           <div>
//                             <h4
//                               style={{
//                                 color: "#ee373b",
//                                 textDecoration: "underline",
//                                 fontWeight: "bold",
//                               }}
//                             >
//                               Basic Details
//                             </h4>

//                             <div className="form-group mb-3">
//                               <label htmlFor="zone">Zone*</label>
//                               <select
//                                 className="form-control"
//                                 id="zone"
//                                 value={selectedZone || ""}
//                                 onChange={(e) =>
//                                   setSelectedZone(Number(e.target.value))
//                                 }
//                                 required
//                               >
//                                 <option value="">Select Zone</option>
//                                 {zones.map((zone) => (
//                                   <option key={zone.zoneId} value={zone.zoneId}>
//                                     {zone.zoneDescription}
//                                   </option>
//                                 ))}
//                               </select>
//                               {validationErrors.zone && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.zone}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="region">Region*</label>
//                               <select
//                                 className="form-control"
//                                 id="region"
//                                 value={selectedRegionId || ""}
//                                 onChange={(e) => {
//                                   const selectedRegion = regions.find(
//                                     (r) => r.regionId === Number(e.target.value)
//                                   );
//                                   setSelectedRegionId(Number(e.target.value));
//                                   setRegion(
//                                     selectedRegion?.regionDescription || ""
//                                   );
//                                 }}
//                                 disabled={!selectedZone}
//                                 required
//                               >
//                                 <option value="">Select Region</option>
//                                 {regions.map((region) => (
//                                   <option
//                                     key={region.regionId}
//                                     value={region.regionId}
//                                   >
//                                     {region.regionDescription}
//                                   </option>
//                                 ))}
//                               </select>
//                               {validationErrors.region && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.region}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="branch">Branch*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="branch"
//                                 placeholder="Enter Branch"
//                                 style={{
//                                   maxWidth:"unset"
//                                 }}
//                                 value={branch}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setBranch,
//                                     "branch",
//                                     e.target.value,
//                                     (value) => validateRequired(value, "Branch")
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.branch && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.branch}
//                                 </div>
//                               )}
//                             </div>
//                             <button
//                               type="button"
//                               className="btn btn-danger btn-block w-100"
//                               onClick={nextStep}
//                             >
//                               Next
//                             </button>
//                           </div>
//                         )}
//                         {step === 2 && (
//                           <div>
//                             <h4
//                               style={{
//                                 color: "#ee373b",
//                                 textDecoration: "underline",
//                                 fontWeight: "bold",
//                               }}
//                             >
//                               Primary Contact Details
//                             </h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="mobileNumber">
//                                 Mobile Number*
//                               </label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="mobileNumber"
//                                 placeholder="Enter your Mobile Number"
//                                 value={mobileNumber}
//                                 disabled={true}
//                                 maxLength="10"
//                                 required
//                               />
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="email">Email*</label>
//                               <input
//                                 type="email"
//                                 className="form-control"
//                                 id="email"
//                                 placeholder="Enter Email"
//                                 value={email}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setEmail,
//                                     "email",
//                                     e.target.value,
//                                     validateEmail
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.email && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.email}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="managerName">Manager Name*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="managerName"
//                                 placeholder="Enter Manager Name"
//                                 style={{
//                                   maxWidth:"unset"
//                                 }}
//                                 value={managerName}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setManagerName,
//                                     "managerName",
//                                     e.target.value,
//                                     (value) =>
//                                       validateRequired(value, "Manager Name")
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.managerName && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.managerName}
//                                 </div>
//                               )}
//                             </div>
//                             <button
//                               type="button"
//                               className="btn btn-secondary btn-block w-100"
//                               onClick={prevStep}
//                             >
//                               Previous
//                             </button>
//                             <button
//                               type="button"
//                               className="btn btn-danger btn-block w-100"
//                               onClick={nextStep}
//                             >
//                               Next
//                             </button>
//                           </div>
//                         )}
//                         {step === 3 && (
//                           <div>
//                             <h4
//                               style={{
//                                 color: "#ee373b",
//                                 textDecoration: "underline",
//                                 fontWeight: "bold",
//                               }}
//                             >
//                               Point of Contact Details
//                             </h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="pocName">
//                                 Point of Contact Name*
//                               </label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="pocName"
//                                 placeholder="Enter Point of Contact Name"
//                                 value={pocName}
//                                 style={{
//                                   maxWidth:"unset"
//                                 }}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setPocName,
//                                     "pocName",
//                                     e.target.value,
//                                     (value) =>
//                                       validateRequired(
//                                         value,
//                                         "Point of Contact Name"
//                                       )
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.pocName && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.pocName}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="lenderPocNumber">
//                                 Point of Contact Number*
//                               </label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="lenderPocNumber"
//                                 placeholder="Enter Point of Contact Number"
//                                 value={lenderPocNumber}
//                                 style={{
//                                   maxWidth:"unset"
//                                 }}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setLenderPocNumber,
//                                     "lenderPocNumber",
//                                     e.target.value
//                                       .replace(/\D/g, "")
//                                       .slice(0, 10),
//                                     validateMobile
//                                   )
//                                 }
//                                 maxLength="10"
//                                 required
//                               />
//                               {validationErrors.lenderPocNumber && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.lenderPocNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="lenderPocEmail">
//                                 Point of Contact Email*
//                               </label>
//                               <input
//                                 type="email"
//                                 className="form-control"
//                                 id="lenderPocEmail"
//                                 placeholder="Enter Point of Contact Email"
//                                 value={lenderPocEmail}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setLenderPocEmail,
//                                     "lenderPocEmail",
//                                     e.target.value,
//                                     validateEmail
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.lenderPocEmail && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.lenderPocEmail}
//                                 </div>
//                               )}
//                             </div>
//                             <button
//                               type="button"
//                               className="btn btn-secondary btn-block w-100"
//                               onClick={prevStep}
//                             >
//                               Previous
//                             </button>
//                             <button
//                               type="button"
//                               className="btn btn-danger btn-block w-100"
//                               onClick={nextStep}
//                             >
//                               Next
//                             </button>
//                           </div>
//                         )}
//                         {step === 4 && (
//                           <div>
//                             <h4
//                               style={{
//                                 color: "#ee373b",
//                                 textDecoration: "underline",
//                                 fontWeight: "bold",
//                               }}
//                             >
//                               Location Details
//                             </h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="lenderCity">Bank Location*</label>
//                               <select
//                                 className="form-control"
//                                 id="lenderCity"
//                                 value={lenderCity}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setLenderCity,
//                                     "lenderCity",
//                                     e.target.value,
//                                     (value) =>
//                                       validateRequired(value, "Bank Location")
//                                   )
//                                 }
//                                 required
//                               >
//                                 <option value="">Select Bank Location</option>
//                                 {[
//                                   "Mumbai",
//                                   "Delhi",
//                                   "Bangalore",
//                                   "Hyderabad",
//                                   "Chennai",
//                                   "Kolkata",
//                                   "Pune",
//                                   "Ahmedabad",
//                                   "Jaipur",
//                                   "Lucknow",
//                                 ].map((city) => (
//                                   <option key={city} value={city}>
//                                     {city}
//                                   </option>
//                                 ))}
//                               </select>
//                               {validationErrors.lenderCity && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.lenderCity}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="state">State*</label>
//                               <select
//                                 className="form-control"
//                                 id="state"
//                                 value={state}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setState,
//                                     "state",
//                                     e.target.value,
//                                     (value) => validateRequired(value, "State")
//                                   )
//                                 }
//                                 required
//                               >
//                                 <option value="">Select State</option>
//                                 {[
//                                   "Andhra Pradesh",
//                                   "Arunachal Pradesh",
//                                   "Assam",
//                                   "Bihar",
//                                   "Chhattisgarh",
//                                   "Goa",
//                                   "Gujarat",
//                                   "Haryana",
//                                   "Himachal Pradesh",
//                                   "Jharkhand",
//                                   "Karnataka",
//                                   "Kerala",
//                                   "Madhya Pradesh",
//                                   "Maharashtra",
//                                   "Manipur",
//                                   "Meghalaya",
//                                   "Mizoram",
//                                   "Nagaland",
//                                   "Odisha",
//                                   "Punjab",
//                                   "Rajasthan",
//                                   "Sikkim",
//                                   "Tamil Nadu",
//                                   "Telangana",
//                                   "Tripura",
//                                   "Uttar Pradesh",
//                                   "Uttarakhand",
//                                   "West Bengal",
//                                 ].map((stateOption) => (
//                                   <option key={stateOption} value={stateOption}>
//                                     {stateOption}
//                                   </option>
//                                 ))}
//                               </select>
//                               {validationErrors.state && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.state}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="address">Address*</label>
//                               <textarea
//                                 className="form-control"
//                                 id="address"
//                                 placeholder="Enter Address"
//                                 value={address}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setAddress,
//                                     "address",
//                                     e.target.value,
//                                     (value) =>
//                                       validateRequired(value, "Address")
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.address && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.address}
//                                 </div>
//                               )}
//                             </div>
//                             <button
//                               type="button"
//                               className="btn btn-secondary btn-block w-100"
//                               onClick={prevStep}
//                             >
//                               Previous
//                             </button>
//                             <button
//                               type="button"
//                               className="btn btn-danger btn-block w-100"
//                               onClick={nextStep}
//                             >
//                               Next
//                             </button>
//                           </div>
//                         )}
//                         {step === 5 && (
//                           <div>
//                             <h4
//                               style={{
//                                 color: "#ee373b",
//                                 textDecoration: "underline",
//                                 fontWeight: "bold",
//                               }}
//                             >
//                               Financial Details
//                             </h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="lenderGstNumber">
//                                 GST Number*
//                               </label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="lenderGstNumber"
//                                 placeholder="Enter GST Number"
//                                 value={lenderGstNumber}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setLenderGstNumber,
//                                     "lenderGstNumber",
//                                     e.target.value.toUpperCase(),
//                                     validateGST
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.lenderGstNumber && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.lenderGstNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="lenderPanNumber">
//                                 PAN Number*
//                               </label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="lenderPanNumber"
//                                 placeholder="Enter PAN Number"
//                                 value={lenderPanNumber}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setLenderPanNumber,
//                                     "lenderPanNumber",
//                                     e.target.value.toUpperCase(),
//                                     validatePAN
//                                   )
//                                 }
//                                 maxLength="10"
//                                 required
//                               />
//                               {validationErrors.lenderPanNumber && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.lenderPanNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <button
//                               type="button"
//                               className="btn btn-secondary btn-block w-100"
//                               onClick={prevStep}
//                             >
//                               Previous
//                             </button>
//                             <button
//                               type="submit"
//                               className="btn btn-danger btn-block w-100"
//                             >
//                               Register
//                             </button>
//                           </div>
//                         )}
//                       </form>
//                     ) : (
//                       <form onSubmit={handleVendorRegistration}>
//                         {vendorStep === 1 && (
//                           <div>
//                             <h4
//                               style={{
//                                 color: "#ee373b",
//                                 textDecoration: "underline",
//                                 fontWeight: "bold",
//                               }}
//                             >
//                               Basic Details
//                             </h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="dealerName">Dealer Name*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="dealerName"
//                                 placeholder="Enter Dealer Name"
//                                 value={dealerName}
//                                 style={{
//                                   maxWidth:"unset"
//                                 }}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setDealerName,
//                                     "dealerName",
//                                     e.target.value,
//                                     (value) =>
//                                       validateRequired(value, "Dealer Name")
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.dealerName && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.dealerName}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="location">Location*</label>
//                               <select
//                                 className="form-control"
//                                 id="location"
//                                 value={location}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setLocation,
//                                     "location",
//                                     e.target.value,
//                                     (value) =>
//                                       validateRequired(value, "Location")
//                                   )
//                                 }
//                                 required
//                               >
//                                 <option value="">Select Location</option>
//                                 {[
//                                   "Mumbai",
//                                   "Delhi",
//                                   "Bangalore",
//                                   "Hyderabad",
//                                   "Chennai",
//                                   "Kolkata",
//                                   "Pune",
//                                   "Ahmedabad",
//                                   "Jaipur",
//                                   "Lucknow",
//                                 ].map((loc) => (
//                                   <option key={loc} value={loc}>
//                                     {loc}
//                                   </option>
//                                 ))}
//                               </select>
//                               {validationErrors.location && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.location}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="vendorManagerName">
//                                 Manager Name*
//                               </label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="vendorManagerName"
//                                 placeholder="Enter Manager Name"
//                                 value={vendorManagerName}
//                                 style={{
//                                   maxWidth:"unset"
//                                 }}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setVendorManagerName,
//                                     "vendorManagerName",
//                                     e.target.value,
//                                     (value) =>
//                                       validateRequired(value, "Manager Name")
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.vendorManagerName && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.vendorManagerName}
//                                 </div>
//                               )}
//                             </div>
//                             <button
//                               type="button"
//                               className="btn btn-danger btn-block w-100"
//                               onClick={nextStep}
//                             >
//                               Next
//                             </button>
//                           </div>
//                         )}
//                         {vendorStep === 2 && (
//                           <div>
//                             <h4
//                               style={{
//                                 color: "#ee373b",
//                                 textDecoration: "underline",
//                                 fontWeight: "bold",
//                               }}
//                             >
//                               Contact Details
//                             </h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="mobileNumber">
//                                 Mobile Number*
//                               </label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="mobileNumber"
//                                 placeholder="Enter your Mobile Number"
//                                 value={mobileNumber}
//                                 disabled={true}
//                                 maxLength="10"
//                                 required
//                               />
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="vendorEmail">Email ID*</label>
//                               <input
//                                 type="email"
//                                 className="form-control"
//                                 id="vendorEmail"
//                                 placeholder="Enter Email"
//                                 value={vendorEmail}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setVendorEmail,
//                                     "vendorEmail",
//                                     e.target.value,
//                                     validateEmail
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.vendorEmail && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.vendorEmail}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="vendorPocName">
//                                 Point of Contact Name*
//                               </label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="vendorPocName"
//                                 placeholder="Enter Point of Contact Name"
//                                 value={vendorPocName}
//                                 style={{
//                                   maxWidth:"unset"
//                                 }}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setVendorPocName,
//                                     "vendorPocName",
//                                     e.target.value,
//                                     (value) =>
//                                       validateRequired(
//                                         value,
//                                         "Point of Contact Name"
//                                       )
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.vendorPocName && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.vendorPocName}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="vendorPocNumber">
//                                 Point of Contact Number*
//                               </label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="vendorPocNumber"
//                                 placeholder="Enter Point of Contact Number"
//                                 value={vendorPocNumber}
//                                 style={{
//                                   maxWidth:"unset"
//                                 }}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setVendorPocNumber,
//                                     "vendorPocNumber",
//                                     e.target.value
//                                       .replace(/\D/g, "")
//                                       .slice(0, 10),
//                                     validateMobile
//                                   )
//                                 }
//                                 maxLength="10"
//                                 required
//                               />
//                               {validationErrors.vendorPocNumber && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.vendorPocNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="vendorPocEmail">
//                                 Point of Contact Email*
//                               </label>
//                               <input
//                                 type="email"
//                                 className="form-control"
//                                 id="vendorPocEmail"
//                                 placeholder="Enter Point of Contact Email"
//                                 value={vendorPocEmail}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setVendorPocEmail,
//                                     "vendorPocEmail",
//                                     e.target.value,
//                                     validateEmail
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.vendorPocEmail && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.vendorPocEmail}
//                                 </div>
//                               )}
//                             </div>
//                             <button
//                               type="button"
//                               className="btn btn-secondary btn-block w-100"
//                               onClick={prevStep}
//                             >
//                               Previous
//                             </button>
//                             <button
//                               type="button"
//                               className="btn btn-danger btn-block w-100"
//                               onClick={nextStep}
//                             >
//                               Next
//                             </button>
//                           </div>
//                         )}
//                         {vendorStep === 3 && (
//                           <div>
//                             <h4
//                               style={{
//                                 color: "#ee373b",
//                                 textDecoration: "underline",
//                                 fontWeight: "bold",
//                               }}
//                             >
//                               Advanced Details
//                             </h4>
//                             <div className="form-group mb-3">
//                               <label htmlFor="gstNumber">GST Number*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="gstNumber"
//                                 placeholder="Enter GST Number"
//                                 value={gstNumber}
//                                 style={{
//                                   maxWidth:"unset"
//                                 }}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setGstNumber,
//                                     "gstNumber",
//                                     e.target.value.toUpperCase(),
//                                     validateGST
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.gstNumber && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.gstNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="panNumber">PAN Number*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="panNumber"
//                                 placeholder="Enter PAN Number"
//                                 value={panNumber}
//                                 style={{
//                                   maxWidth:"unset"
//                                 }}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setPanNumber,
//                                     "panNumber",
//                                     e.target.value.toUpperCase(),
//                                     validatePAN
//                                   )
//                                 }
//                                 maxLength="10"
//                                 required
//                               />
//                               {validationErrors.panNumber && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.panNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="accountNumber">
//                                 Bank Account Number*
//                               </label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="accountNumber"
//                                 placeholder="Enter Bank Account Number"
//                                 value={accountNumber}
//                                 style={{
//                                   maxWidth:"unset"
//                                 }}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setAccountNumber,
//                                     "accountNumber",
//                                     e.target.value.replace(/\D/g, ""),
//                                     validateAccountNumber
//                                   )
//                                 }
//                                 required
//                               />
//                               {validationErrors.accountNumber && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.accountNumber}
//                                 </div>
//                               )}
//                             </div>
//                             <div className="form-group mb-3">
//                               <label htmlFor="ifscCode">IFSC Code*</label>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 id="ifscCode"
//                                 placeholder="Enter IFSC Code"
//                                 value={ifscCode}
//                                 style={{
//                                   maxWidth:"unset"
//                                 }}
//                                 onChange={(e) =>
//                                   handleFieldChange(
//                                     setIfscCode,
//                                     "ifscCode",
//                                     e.target.value.toUpperCase(),
//                                     validateIFSC
//                                   )
//                                 }
//                                 maxLength="11"
//                                 required
//                               />
//                               {validationErrors.ifscCode && (
//                                 <div
//                                   className="text-danger mt-1 bg-white"
//                                   style={{ fontSize: "0.8rem" }}
//                                 >
//                                   {validationErrors.ifscCode}
//                                 </div>
//                               )}
//                             </div>
//                             <button
//                               type="button"
//                               className="btn btn-secondary btn-block w-100"
//                               onClick={prevStep}
//                             >
//                               Previous
//                             </button>
//                             <button
//                               type="submit"
//                               className="btn btn-danger btn-block w-100"
//                             >
//                               Register
//                             </button>
//                           </div>
//                         )}
//                       </form>
//                     )}
//                   </div>
//                 )}
//                 <p className="mt-3 text-center">
//                   Already have an account?{" "}
//                   <a href="#" style={{ color: "#ee373b" }} onClick={toggleView}>
//                     Login
//                   </a>
//                 </p>
//                 {userType == "lender" && (
//                   <p className="mt-3 text-center">
//                     Want to Onboard?{" "}
//                     <a
//                       style={{ color: "#ee373b" }}
//                       href="#"
//                       onClick={() => {
//                         nav("/masterLogin");
//                       }}
//                     >
//                       Onboard
//                     </a>
//                   </p>
//                 )}
//               </div>
//             )}
//             <InformationModal
//               isOpen={isModalOpen}
//               onClose={() => {
//                 setIsModalOpen(false);
//                 setModalMessage("");
//                 if (isRegisterVerifyEnabled && isOTPVerified) {
//                   setIsLogin(true);
//                 }
//               }}
//               message={modalMessage}
//             />
//             {showAgreementModal && (
//               <PopupModal
//                 onClose={handleAgreementCancel}
//                 onAgree={handleAgreementAgree}
//                 policies={policies}
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CombinedLoginRegister;

//-----------------------------------with email OTP----------------

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "altcha";
import Cookies from "js-cookie";
import "bootstrap/dist/css/bootstrap.min.css";
import "./RegLogin.css";
import logo from "../assets/logo.png";
import InformationModal from "../components/InformationModal";
import PopupModal from "../components/AgreementModal";
import { encryptObject } from "../utils/cryptoUtil";

const CombinedLoginRegister = () => {
  const [userType, setUserType] = useState("vendor");
  const [mobileNumber, setMobileNumber] = useState("");
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [showRegisterOTP, setShowRegisterOTP] = useState(false);
  const [registerOTP, setRegisterOTP] = useState(["", "", "", "", "", ""]);
  const [isRegisterVerifyEnabled, setIsRegisterVerifyEnabled] = useState(false);
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [showEmailOTP, setShowEmailOTP] = useState(false);
  const [emailOTP, setEmailOTP] = useState(["", "", "", "", "", ""]);
  const [isEmailVerifyEnabled, setIsEmailVerifyEnabled] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [lenderCity, setLenderCity] = useState("");
  const [branch, setBranch] = useState("");
  const [state, setState] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [pocName, setPocName] = useState("");
  const [managerName, setManagerName] = useState("");
  const [region, setRegion] = useState("");
  const [dealerName, setDealerName] = useState("");
  const [location, setLocation] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [vendorEmail, setVendorEmail] = useState("");
  const [vendorPocName, setVendorPocName] = useState("");
  const [vendorManagerName, setVendorManagerName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [vendorPocNumber, setVendorPocNumber] = useState("");
  const [vendorPocEmail, setVendorPocEmail] = useState("");
  const [lenderPocNumber, setLenderPocNumber] = useState("");
  const [lenderPocEmail, setLenderPocEmail] = useState("");
  const [lenderGstNumber, setLenderGstNumber] = useState("");
  const [lenderPanNumber, setLenderPanNumber] = useState("");

  const [validationErrors, setValidationErrors] = useState({
    branch: "",
    region: "",
    mobileNumber: "",
    email: "",
    pocName: "",
    managerName: "",
    lenderCity: "",
    state: "",
    address: "",
    dealerName: "",
    location: "",
    vendorEmail: "",
    vendorPocName: "",
    vendorManagerName: "",
    gstNumber: "",
    panNumber: "",
    accountNumber: "",
    ifscCode: "",
    vendorPocNumber: "",
    vendorPocEmail: "",
    lenderPocNumber: "",
    lenderPocEmail: "",
    lenderGstNumber: "",
    lenderPanNumber: "",
  });
  const [isLogin, setIsLogin] = useState(true);
  const [step, setStep] = useState(1);
  const [vendorStep, setVendorStep] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [policies, setPolicies] = useState({});
  const [countdown, setCountdown] = useState(60);
  const [masterLenders, setMasterLenders] = useState([]);
  const [selectedMasterLender, setSelectedMasterLender] = useState(null);
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);
  const [regions, setRegions] = useState([]);
  const [selectedRegionId, setSelectedRegionId] = useState(null);
  const [lenderType, setLenderType] = useState("");
  const [altchaPayload, setAltchaPayload] = useState(null);

  const nav = useNavigate();

  useEffect(() => {
    const isAuthenticated = Cookies.get("adminAuthStatus") === "true";
    if (isAuthenticated) {
      nav("/dashboard");
    }
  }, [nav]);

  const [captchaKey, setCaptchaKey] = useState(0);

  useEffect(() => {
    const container = document.getElementById("altcha-container");
    if (container) {
      container.innerHTML = "";
      const widget = document.createElement("altcha-widget");
      widget.setAttribute(
        "challengeurl",
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/captcha-challenge?v=${Date.now()}`
      );
      widget.setAttribute("name", "altcha_" + Date.now());
      widget.setAttribute("auto", "true");
      widget.setAttribute("hidefooter", "true");
      widget.setAttribute("hidelogo", "true");
      widget.setAttribute("refreshonexpire", "true");

      widget.addEventListener("verified", (e) => {
        setAltchaPayload(e.detail.payload);
      });

      container.appendChild(widget);
    }
  }, [isLogin, userType, captchaKey]);

  useEffect(() => {
    if (userType === "lender") {
      fetchMasterLenders();
    }
  }, [userType]);

  useEffect(() => {
    if (selectedMasterLender) {
      const selectedLender = masterLenders.find(
        (ml) => ml.id === selectedMasterLender
      );
      console.log("lender type ===>", selectedLender.userType);
      if (selectedLender) {
        setLenderType(selectedLender.userType);
        const zonesData = selectedLender.zones || [];
        setZones(zonesData);
      }
      setSelectedZone(null);
      setRegions([]);
      setSelectedRegionId(null);
    }
  }, [selectedMasterLender, masterLenders]);

  useEffect(() => {
    if (selectedZone) {
      const zoneData = zones.find((z) => z.zoneId === selectedZone);
      const regionsData = zoneData?.regions || [];
      setRegions(regionsData);
      setSelectedRegionId(null);
    }
  }, [selectedZone, zones]);

  useEffect(() => {
    const isComplete = emailOTP.every((digit) => digit.length === 1);
    setIsEmailVerifyEnabled(isComplete);
  }, [emailOTP]);

  const fetchMasterLenders = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/getMasterLendersWithDetails`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      console.log("master lender data ==>", data);
      setMasterLenders(data);
    } catch (error) {
      console.error("Error fetching master lenders:", error);
    }
  };

  const getApiEndpoint = (endpointType) => {
    const endpoints = {
      Lender: {
        sendOTP: "sendOTPLender",
        validateOTP: "validateOTPLender",
        sendRegOTP: "sendRegOTPLender",
        validateRegOTP: "validateRegOTPLender",
        register: "registerLender",
        agreement: "agreementLender",
      },
      Private_Lender: {
        sendOTP: "sendOTPPrivateLender",
        validateOTP: "validateOTPPrivateLender",
        sendRegOTP: "sendRegOTPPrivateLender",
        validateRegOTP: "validateRegOTPPrivateLender",
        register: "registerLender",
        agreement: "agreementLender",
      },
    };
    return (
      endpoints[lenderType.replace(" ", "_")]?.[endpointType] ||
      endpoints["Lender"][endpointType]
    );
  };

  const handleOtpChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const newOtp = [...otp];
      newOtp[index - 1] = "";
      setOtp(newOtp);
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const handleRegisterOtpChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...registerOTP];
      newOtp[index] = value;
      setRegisterOTP(newOtp);
      if (value && index < 5) {
        document.getElementById(`register-otp-${index + 1}`).focus();
      }
    }
  };

  const handleRegisterOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !registerOTP[index] && index > 0) {
      const newOtp = [...registerOTP];
      newOtp[index - 1] = "";
      setRegisterOTP(newOtp);
      document.getElementById(`register-otp-${index - 1}`).focus();
    }
  };

  const handleEmailOtpChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...emailOTP];
      newOtp[index] = value;
      setEmailOTP(newOtp);
      if (value && index < 5) {
        document.getElementById(`email-otp-${index + 1}`).focus();
      }
    }
  };

  const handleEmailOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !emailOTP[index] && index > 0) {
      const newOtp = [...emailOTP];
      newOtp[index - 1] = "";
      setEmailOTP(newOtp);
      document.getElementById(`email-otp-${index - 1}`).focus();
    }
  };



  useEffect(() => {
    const isComplete = registerOTP.every((digit) => digit.length === 1);
    setIsRegisterVerifyEnabled(isComplete);
  }, [registerOTP]);

  useEffect(() => {
    if (showOTP && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [showOTP, countdown]);

  const toggleView = () => {
    setIsLogin(!isLogin);
    setShowOTP(false);
    setOtp(["", "", "", "", "", ""]);
    setMobileNumber("");
    setStep(1);
    setVendorStep(1);
    setShowRegisterOTP(false);
    setRegisterOTP(["", "", "", "", "", ""]);
    setIsOTPVerified(false);
    setAltchaPayload(null);
    setValidationErrors({
      branch: "",
      region: "",
      mobileNumber: "",
      email: "",
      pocName: "",
      managerName: "",
      lenderCity: "",
      state: "",
      address: "",
      dealerName: "",
      location: "",
      vendorEmail: "",
      vendorPocName: "",
      vendorManagerName: "",
      gstNumber: "",
      panNumber: "",
      accountNumber: "",
      ifscCode: "",
    });
  };

  const userToggle = (type) => {
    setUserType(type);
    setShowOTP(false);
    setMobileNumber("");
    setCountdown(10);
    setAltchaPayload(null);
  };

  const validateRequired = (value, fieldName) => {
    if (!value || value.toString().trim() === "") {
      return `${fieldName} is required`;
    }
    return "";
  };

  const validateEmail = (email) => {
    if (!email || email.trim() === "") {
      return "Email is required";
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return "Please enter a valid email address";
    }
    return "";
  };

  const validateMobile = (mobile) => {
    if (!mobile || mobile.trim() === "") {
      return "Mobile number is required";
    }
    if (!/^\d{10}$/.test(mobile)) {
      return "Mobile number must be 10 digits";
    }
    return "";
  };

  const validateGST = (gst) => {
    if (!gst || gst.trim() === "") {
      return "GST Number is required";
    }
    if (
      !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst)
    ) {
      return "Please enter a valid GST number";
    }
    return "";
  };

  const validatePAN = (pan) => {
    if (!pan || pan.trim() === "") {
      return "PAN Number is required";
    }
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
      return "Please enter a valid PAN number";
    }
    return "";
  };

  const validateIFSC = (ifsc) => {
    if (!ifsc || ifsc.trim() === "") {
      return "IFSC Code is required";
    }
    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc)) {
      return "Please enter a valid IFSC code";
    }
    return "";
  };

  const validateAccountNumber = (accountNumber) => {
    if (!accountNumber || accountNumber.trim() === "") {
      return "Account number is required";
    }
    if (!/^\d{9,18}$/.test(accountNumber)) {
      return "Account number should be between 9 to 18 digits";
    }
    return "";
  };

  const handleFieldChange = (setter, fieldName, value, validator) => {
    setter(value);
    setValidationErrors({
      ...validationErrors,
      [fieldName]: validator(value),
    });
  };

  const validateLenderStep1 = () => {
    const newErrors = { ...validationErrors };
    let isValid = true;
    newErrors.branch = validateRequired(branch, "Branch");
    newErrors.region = validateRequired(selectedRegionId, "Region");
    isValid = !newErrors.branch && !newErrors.region;
    setValidationErrors(newErrors);
    return isValid;
  };

  const validateLenderForm = () => {
    let isValid = true;
    const newErrors = { ...validationErrors };
    newErrors.branch = validateRequired(branch, "Branch");
    newErrors.region = validateRequired(selectedRegionId, "Region");
    newErrors.mobileNumber = validateMobile(mobileNumber);
    newErrors.email = validateEmail(email);
    newErrors.pocName = validateRequired(pocName, "Point of Contact Name");
    newErrors.managerName = validateRequired(managerName, "Manager Name");
    newErrors.lenderCity = validateRequired(lenderCity, "Bank Location");
    newErrors.state = validateRequired(state, "State");
    newErrors.address = validateRequired(address, "Address");
    newErrors.lenderPocNumber = validateMobile(lenderPocNumber);
    newErrors.lenderPocEmail = validateEmail(lenderPocEmail);
    // newErrors.lenderGstNumber = validateGST(lenderGstNumber);
    // newErrors.lenderPanNumber = validatePAN(lenderPanNumber);
    setValidationErrors(newErrors);
    isValid = !Object.values(newErrors).some((error) => error !== "");
    return isValid;
  };

  const validateVendorForm = () => {
    let isValid = true;
    const newErrors = { ...validationErrors };
    newErrors.dealerName = validateRequired(dealerName, "Dealer Name");
    newErrors.mobileNumber = validateMobile(mobileNumber);
    newErrors.location = validateRequired(location, "Location");
    newErrors.vendorEmail = validateEmail(vendorEmail);
    newErrors.vendorPocName = validateRequired(
      vendorPocName,
      "Point of Contact Name"
    );
    newErrors.vendorManagerName = validateRequired(
      vendorManagerName,
      "Manager Name"
    );
    newErrors.gstNumber = validateGST(gstNumber);
    newErrors.panNumber = validatePAN(panNumber);
    newErrors.accountNumber = validateAccountNumber(accountNumber);
    newErrors.ifscCode = validateIFSC(ifscCode);
    newErrors.vendorPocNumber = validateMobile(vendorPocNumber);
    newErrors.vendorPocEmail = validateEmail(vendorPocEmail);
    setValidationErrors(newErrors);
    isValid = !Object.values(newErrors).some((error) => error !== "");
    return isValid;
  };

  const handleSendOtp = async () => {
    if (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber)) {
      return;
    }
    const apiEndpoint =
      userType === "lender" ? getApiEndpoint("sendOTP") : "sendOTPVendor";
    console.log("user Type =>", userType);
    console.log("apiEndpoint =>", apiEndpoint);
    var bodyData =
      userType === "lender"
        ? {
            masterLenderName: masterLenders.find(
              (item) => item.id === selectedMasterLender
            )?.lenderName,
            number: mobileNumber,
            masterLenderId: selectedMasterLender,
          }
        : {
            number: mobileNumber,
            masterLenderId: selectedMasterLender,
          };
    if (!altchaPayload) {
      setIsModalOpen(true);
      setModalMessage("Please complete the CAPTCHA");
      return;
    }
    const bodyWithCaptcha = { ...bodyData, altchaPayload };
    console.log("body data =>", bodyWithCaptcha);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          body: JSON.stringify({
            ...encryptObject(bodyData),
            altchaPayload,
          }),
        }
      );
      const data = await response.json();
      if (response.ok && data.success) {
        setShowOTP(true);
        setCountdown(60);
      } else {
        setIsModalOpen(true);
        setModalMessage(data.message || data.error || "Failed to send OTP. Please try again.");
        setAltchaPayload(null);
        setCaptchaKey((prev) => prev + 1); // Refresh CAPTCHA on error
        
        if (data.message && data.message.includes("Active session detected")) {
             setShowOTP(true);
             setCountdown(60);
        }
      }
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error sending OTP: ${error.message}`);
    }
  };

  const handleVerifyOtp = async () => {
    const isOtpComplete = otp.every((digit) => digit.length === 1);
    if (!isOtpComplete) {
      return;
    }
    const apiEndpoint =
      userType === "lender"
        ? getApiEndpoint("validateOTP")
        : "validateOTPVendor";
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          body: JSON.stringify(encryptObject({
            number: mobileNumber,
            otp: otp.join(""),
            masterLenderId: selectedMasterLender,
          })),
          credentials: "include",
        }
      );
      const data = await response.json();
      if (data.isValidOTP || data.message === "OTP validated successfully") {
        nav("/dashboard");
      } else {
        setIsModalOpen(true);
        setModalMessage("Invalid OTP");
      }
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error verifying OTP: ${error.message}`);
    }
  };

  const handleSendRegisterOtp = async () => {
    if (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber)) {
      return;
    }
    const apiEndpoint =
      userType === "lender" ? getApiEndpoint("sendRegOTP") : "sendRegOTPVendor";
    if (!altchaPayload) {
      setIsModalOpen(true);
      setModalMessage("Please complete the CAPTCHA");
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          body: JSON.stringify({
            ...encryptObject({
              number: mobileNumber,
              masterLenderId: selectedMasterLender,
            }),
            altchaPayload,
          }),
        }
      );
      const data = await response.json();
      if (data.success || data.message.includes("OTP sent")) {
        setShowRegisterOTP(true);
      } else if (data.message.includes("already")) {
        setIsModalOpen(true);
        setModalMessage(data.message);
      } else {
        setIsModalOpen(true);
        setModalMessage("Failed to send OTP");
      }
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error sending OTP: ${error.message}`);
    }
  };

  const handleVerifyRegisterOtp = async () => {
    const isRegisterOtpComplete = registerOTP.every(
      (digit) => digit.length === 1
    );
    if (!isRegisterOtpComplete) {
      return;
    }
    const apiEndpoint =
      userType === "lender"
        ? getApiEndpoint("validateRegOTP")
        : "validateRegOTPVendor";
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          body: JSON.stringify(encryptObject({
            number: mobileNumber,
            otp: registerOTP.join(""),
            masterLenderId: selectedMasterLender,
          })),
          credentials: "include",
        }
      );
      const data = await response.json();
      if (data.isValidOTP || data.message === "OTP validated successfully") {
        // setIsOTPVerified(true);
        setShowRegisterOTP(false);
        setIsMobileVerified(true);
      } else {
        setIsModalOpen(true);
        setModalMessage("Invalid OTP");
      }
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error verifying OTP: ${error.message}`);
    }
  };

  const handleSendEmailOtp = async () => {
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setValidationErrors({
        ...validationErrors,
        email: "Please enter a valid email address",
      });
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/sendRegOTPEmail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          body: JSON.stringify(encryptObject({ email })),
        }
      );
      const data = await response.json();
      if (data.success) {
        setShowEmailOTP(true);
        setCountdown(60);
      } else {
        setIsModalOpen(true);
        setModalMessage(data.message || "Failed to send OTP");
      }
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error sending OTP: ${error.message}`);
    }
  };

  const handleVerifyEmailOtp = async () => {
    if (!isEmailVerifyEnabled) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/validateRegOTPEmail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          body: JSON.stringify(encryptObject({
            email,
            otp: emailOTP.join(""),
          })),
        }
      );
      const data = await response.json();
      if (data.isValidOTP) {
        setIsEmailVerified(true);
        setShowEmailOTP(false);
        setIsOTPVerified(true);
        // Proceed to next registration step
      } else {
        setIsModalOpen(true);
        setModalMessage(data.message || "Invalid OTP");
      }
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error verifying OTP: ${error.message}`);
    }
  };

  const handleLenderRegistration = async (e) => {
    e.preventDefault();
    if (!validateLenderForm()) {
      return;
    }
    try {
      const apiEndpoint = getApiEndpoint("agreement");
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`,
        {
          method: "GET",
          headers: {
            "X-Full-URL": window.location.href,
          },
        }
      );
      const data = await response.json();
      setPolicies(data);
      setShowAgreementModal(true);
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error fetching agreement: ${error.message}`);
    }
  };

  const handleVendorRegistration = async (e) => {
    e.preventDefault();
    if (!validateVendorForm()) {
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/agreementDealer`,
        {
          method: "GET",
          headers: {
            "X-Full-URL": window.location.href,
          },
        }
      );
      const data = await response.json();
      setPolicies(data);
      setShowAgreementModal(true);
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error fetching agreement: ${error.message}`);
    }
  };

  const handleAgreementAgree = async () => {
    setShowAgreementModal(false);
    if (userType === "lender") {
      try {
        const selectedLender = masterLenders.find(
          (ml) => ml.id === selectedMasterLender
        );
        const apiEndpoint = getApiEndpoint("register");
        const response = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/api/auth/${apiEndpoint}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Full-URL": window.location.href,
            },
            body: JSON.stringify(encryptObject({
              number: mobileNumber,
              lenderName: selectedLender?.lenderName || "",
              lenderCity,
              branch,
              state,
              isActive: true,
              isSuspended: false,
              address,
              email,
              POC: pocName,
              manager: managerName,
              region,
              lenderType: lenderType,
              masterLenderId: selectedMasterLender,
              regionId: selectedRegionId,
              point_of_contact_number: lenderPocNumber,
              point_of_contact_email: lenderPocEmail,
              GST_no: "",
              PAN_no: "",
            })),
          }
        );
        const data = await response.json();
        if (data.success) {
          setIsModalOpen(true);
          setModalMessage("Registration Successful! Please login to continue.");
        }
      } catch (error) {
        setIsModalOpen(true);
        setModalMessage(`Error registering lender: ${error.message}`);
      }
    } else {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/api/auth/registerVendor`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Full-URL": window.location.href,
            },
            body: JSON.stringify(encryptObject({
              number: mobileNumber,
              dealerName,
              GSTNo: gstNumber,
              PANNo: panNumber,
              email: vendorEmail,
              POC: vendorPocName,
              manager: vendorManagerName,
              bankAccountNumber: accountNumber,
              IFSCCode: ifscCode,
              area: "",
              city: location,
              state,
              country: "India",
              point_of_contact_number: vendorPocNumber,
              point_of_contact_email: vendorPocEmail,
            })),
          }
        );
        const data = await response.json();
        if (data.success) {
          setIsModalOpen(true);
          setModalMessage("Registration Successful! Please login to continue.");
        }
      } catch (error) {
        setIsModalOpen(true);
        setModalMessage(`Error registering vendor: ${error.message}`);
      }
    }
  };

  const handleAgreementCancel = () => {
    setShowAgreementModal(false);
  };

  const validateLenderStep3 = () => {
    const newErrors = { ...validationErrors };
    let isValid = true;
    newErrors.pocName = validateRequired(pocName, "Point of Contact Name");
    newErrors.lenderPocNumber = validateMobile(lenderPocNumber);
    newErrors.lenderPocEmail = validateEmail(lenderPocEmail);
    isValid =
      !newErrors.pocName &&
      !newErrors.lenderPocNumber &&
      !newErrors.lenderPocEmail;
    setValidationErrors(newErrors);
    return isValid;
  };

  const validateLenderStep4 = () => {
    const newErrors = { ...validationErrors };
    let isValid = true;
    newErrors.lenderCity = validateRequired(lenderCity, "Bank Location");
    newErrors.state = validateRequired(state, "State");
    newErrors.address = validateRequired(address, "Address");
    isValid = !newErrors.lenderCity && !newErrors.state && !newErrors.address;
    setValidationErrors(newErrors);
    return isValid;
  };


  // Update the existing lender step 2 validation
  const validateLenderStep2 = () => {
    const newErrors = { ...validationErrors };
    let isValid = true;
    newErrors.email = validateEmail(email);
    newErrors.managerName = validateRequired(managerName, "Manager Name");
    isValid = !newErrors.email && !newErrors.managerName;
    setValidationErrors(newErrors);
    return isValid;
  };

  // Update the dealer validation functions
  const validateVendorStep1 = () => {
    const newErrors = { ...validationErrors };
    let isValid = true;
    newErrors.dealerName = validateRequired(dealerName, "Dealer Name");
    newErrors.location = validateRequired(location, "Location");
    newErrors.vendorManagerName = validateRequired(
      vendorManagerName,
      "Manager Name"
    );
    isValid =
      !newErrors.dealerName &&
      !newErrors.location &&
      !newErrors.vendorManagerName;
    setValidationErrors(newErrors);
    return isValid;
  };

  // Validation function for Vendor Step 2
  const validateVendorStep2 = () => {
    const newErrors = { ...validationErrors };
    let isValid = true;

    // Validate Email
    newErrors.vendorEmail = validateEmail(vendorEmail);
    if (newErrors.vendorEmail) isValid = false;

    // Validate Point of Contact Name
    newErrors.vendorPocName = validateRequired(
      vendorPocName,
      "Point of Contact Name"
    );
    if (newErrors.vendorPocName) isValid = false;

    // Validate Point of Contact Number
    newErrors.vendorPocNumber = validateMobile(vendorPocNumber);
    if (newErrors.vendorPocNumber) isValid = false;

    // Validate Point of Contact Email
    newErrors.vendorPocEmail = validateEmail(vendorPocEmail);
    if (newErrors.vendorPocEmail) isValid = false;

    setValidationErrors(newErrors);
    return isValid;
  };

  // Validation function for Vendor Step 3

  // Update the nextStep and prevStep functions to handle the new step structures
  const nextStep = () => {
    let isValid = true;
    if (userType === "vendor") {
      if (vendorStep === 1) {
        isValid = validateVendorStep1();
      } else if (vendorStep === 2) {
        isValid = validateVendorStep2();
      }
      if (isValid) {
        setVendorStep(vendorStep + 1);
      }
    } else {
      if (step === 1) {
        isValid = validateLenderStep1();
      } else if (step === 2) {
        isValid = validateLenderStep2();
      } else if (step === 3) {
        isValid = validateLenderStep3();
      } else if (step === 4) {
        isValid = validateLenderStep4();
      }
      if (isValid) {
        setStep(step + 1);
      }
    }
  };


  const prevStep = () => {
    if (userType === "vendor") {
      if (vendorStep > 1) {
        setVendorStep(vendorStep - 1);
      }
    } else {
      if (step > 1) {
        setStep(step - 1);
      }
    }
  };

  return (
    <div className="login-register-container">
      <div
        className="row h-100 m-0"
        style={{ alignItems: "center", backgroundColor: "white" }}
      >
        <div className="col-12 col-md-12 form-container py-1">
          <div
            className="form-wrapper"
            style={{
              width: "fit-content",
              boxShadow: "0px 0px 5px rgb(0 0 0 / 7%)",
              padding: "1.5rem",
            }}
          >
            <div className="logo-container text-center mb-4">
              <img
                src={logo}
                alt="VVendu Technology Solutions Pvt. Ltd."
                className="img-fluid"
                style={{ height: "15vh" }}
              />
            </div>
            <div className="user-type-toggle mb-4 d-flex justify-content-center">
              <div className="btn-group" style={{ width: "80%" }}>
                <button
                  className={`btn ${
                    userType === "vendor"
                      ? "btn-danger active"
                      : "btn-outline-danger"
                  }`}
                  onClick={() => userToggle("vendor")}
                  style={{ padding: "auto 10px" }}
                >
                  Dealer
                </button>
                <span style={{ width: "20px" }}></span>
                <button
                  className={`btn ${
                    userType === "lender"
                      ? "btn-danger active"
                      : "btn-outline-danger"
                  }`}
                  onClick={() => userToggle("lender")}
                  style={{ padding: "auto 10px" }}
                >
                  Lender
                </button>
              </div>
            </div>
            {userType === "lender" && !isOTPVerified && (
              <div
                className="form-group my-4 mx-auto d-flex justify-content-center align-items-center"
                style={{ maxWidth: "15vw" }}
              >
                <select
                  className="form-select"
                  id="lenderType"
                  value={selectedMasterLender || ""}
                  onChange={(e) =>
                    setSelectedMasterLender(Number(e.target.value))
                  }
                  style={{
                    fontWeight: "bold",
                    textAlign: "center",
                    border: "1.5px solid #ee373b",
                    borderRadius: "6.5px",
                    width: "unset",
                  }}
                  disabled={!isLogin && isOTPVerified}
                >
                  <option value="">------ Select Lender ------</option>
                  {masterLenders.map((lender) => (
                    <option key={lender.id} value={lender.id}>
                      {lender.lenderName}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {!isLogin && (
              <div className="d-flex justify-content-center mb-4">
                <h4
                  className="title-info-text"
                  style={{
                    border: "0px",
                    fontWeight: "bold",
                    marginBottom: "0px",
                    color: "#ee373b",
                  }}
                >
                  {"Register as " +
                    (userType === "vendor" ? "Dealer" : "Lender")}
                </h4>
              </div>
            )}
            {isLogin ? (
              <div className="login-form">
                <div className="form-group mb-4">
                  <label htmlFor="mobileNumber">
                    <b>Enter Mobile Number</b>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      id="mobileNumber"
                      style={{ width: "100%" }}
                      placeholder="Enter your Mobile Number"
                      value={mobileNumber}
                      disabled={!selectedMasterLender && userType === "lender"}
                      onChange={(e) =>
                        setMobileNumber(
                          e.target.value.replace(/\D/g, "").slice(0, 10)
                        )
                      }
                      maxLength="10"
                      required
                    />
                  </div>
                </div>
                {showOTP && (
                  <div className="otp-container mb-4">
                    <div className="d-flex justify-content-between mb-2">
                      <label>OTP</label>
                      <button
                        className="btn btn-outline-danger"
                        style={{ fontSize: "10px", fontWeight: "bold" }}
                        disabled={countdown !== 0}
                        onClick={handleSendOtp}
                      >
                        Resend OTP{" "}
                        {countdown !== 0
                          ? `00:${countdown < 10 ? "0" + countdown : countdown}`
                          : ""}
                      </button>
                    </div>
                    <div className="d-flex justify-content-between">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          id={`otp-${index}`}
                          type="text"
                          className="form-control otp-input"
                          value={digit}
                          onChange={(e) =>
                            handleOtpChange(index, e.target.value)
                          }
                          onKeyDown={(e) => handleOtpKeyDown(index, e)}
                          maxLength="1"
                          required
                        />
                      ))}
                    </div>
                  </div>
                )}
                <div className="mb-3">
                  <div id="altcha-container" className="mb-3"></div>
                </div>
                {!showOTP ? (
                  <button
                    className="btn btn-danger btn-block w-100"
                    onClick={handleSendOtp}
                    disabled={
                      mobileNumber.length !== 10 ||
                      (!selectedMasterLender && userType === "lender")
                    }
                  >
                    Send OTP
                  </button>
                ) : (
                  <button
                    className="btn btn-danger btn-block w-100"
                    onClick={handleVerifyOtp}
                  >
                    Login
                  </button>
                )}
                <p className="mt-3 text-center">
                  New User?{" "}
                  <a href="#!" style={{ color: "#ee373b" }} onClick={(e) => { e.preventDefault(); toggleView(); }}>
                    <b>Register</b>
                  </a>
                </p>
                {userType === "lender" && (
                  <p className="mt-1 text-center">
                    Want to Onboard?{" "}
                    <a
                      style={{ color: "#ee373b" }}
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        nav("/masterLogin");
                      }}
                    >
                      Onboard
                    </a>
                  </p>
                )}
              </div>
            ) : (
              <div className="register-form">
    {!isOTPVerified ? (
      <div>
        {/* Mobile Verification Section */}
        {!isMobileVerified ? (
          <div>
            {!showRegisterOTP ? (
              <div>
                <div className="form-group mb-4">
                  <label htmlFor="mobileNumber">
                    <b>Enter Mobile Number</b>
                  </label>
                  <div
                    className="input-group"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      style={{
                        border: "1.5px solid #ee373b",
                        width: "100%",
                      }}
                      id="mobileNumber"
                      disabled={
                        !selectedMasterLender && userType === "lender"
                      }
                      placeholder="Enter your Mobile Number"
                      value={mobileNumber}
                      onChange={(e) => {
                        const value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setMobileNumber(value);
                        if (!isLogin) {
                          setValidationErrors({
                            ...validationErrors,
                            mobileNumber: validateMobile(value),
                          });
                        }
                      }}
                      maxLength="10"
                      required
                    />
                    {!isLogin && validationErrors.mobileNumber && (
                      <div
                        className="text-danger mt-1 bg-white"
                        style={{ fontSize: "0.8rem" }}
                      >
                        {validationErrors.mobileNumber}
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <div id="altcha-container" className="mb-3"></div>
                </div>
                <button
                  className="btn btn-danger btn-block w-100"
                  onClick={handleSendRegisterOtp}
                  disabled={
                    mobileNumber.length !== 10 ||
                    !!validationErrors.mobileNumber ||
                    (!selectedMasterLender && userType === "lender")
                  }
                >
                  Send OTP
                </button>
              </div>
            ) : (
              <div>
                <div className="otp-container mb-4">
                  <label>OTP</label>
                  <div className="d-flex justify-content-between">
                    {registerOTP.map((digit, index) => (
                      <input
                        key={index}
                        id={`register-otp-${index}`}
                        type="text"
                        className="form-control otp-input"
                        value={digit}
                        onChange={(e) =>
                          handleRegisterOtpChange(index, e.target.value)
                        }
                        onKeyDown={(e) => handleRegisterOtpKeyDown(index, e)}
                        maxLength="1"
                        required
                      />
                    ))}
                  </div>
                </div>
                <button
                  className="btn btn-danger btn-block w-100"
                  onClick={handleVerifyRegisterOtp}
                >
                  Verify Mobile OTP
                </button>
              </div>
            )}
          </div>
        ) : (
          /* Email Verification Section (after mobile is verified) */
          !isEmailVerified ? (
            <div>
              {!showEmailOTP ? (
                <div>
                  <div className="form-group mb-4">
                    <label htmlFor="email"><b>Enter Email Address</b></label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      style={{
                        border: "1.5px solid #ee373b",
                        width: "100%",
                      }}
                      placeholder="Enter your Email Address"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setValidationErrors({
                          ...validationErrors,
                          email: validateEmail(e.target.value)
                        });
                      }}
                      required
                    />
                    {validationErrors.email && (
                      <div className="text-danger mt-1 bg-white" style={{ fontSize: "0.8rem" }}>
                        {validationErrors.email}
                      </div>
                    )}
                  </div>
                  <button
                    className="btn btn-danger btn-block w-100"
                    onClick={handleSendEmailOtp}
                    disabled={!email || !!validationErrors.email}
                  >
                    Send OTP to Email
                  </button>
                </div>
              ) : (
                <div>
                  <div className="otp-container mb-4">
                    <div className="d-flex justify-content-between mb-2">
                      <label>Email OTP</label>
                      <button
                        className="btn btn-outline-danger"
                        style={{ fontSize: "10px", fontWeight: "bold" }}
                        disabled={countdown !== 0}
                        onClick={handleSendEmailOtp}
                      >
                        Resend OTP{" "}
                        {countdown !== 0
                          ? `00:${countdown < 10 ? "0" + countdown : countdown}`
                          : ""}
                      </button>
                    </div>
                    <div className="d-flex justify-content-between">
                      {emailOTP.map((digit, index) => (
                        <input
                          key={index}
                          id={`email-otp-${index}`}
                          type="text"
                          className="form-control otp-input"
                          value={digit}
                          onChange={(e) =>
                            handleEmailOtpChange(index, e.target.value)
                          }
                          onKeyDown={(e) => handleEmailOtpKeyDown(index, e)}
                          maxLength="1"
                          required
                        />
                      ))}
                    </div>
                  </div>
                  <button
                    className="btn btn-danger btn-block w-100"
                    onClick={handleVerifyEmailOtp}
                    disabled={!isEmailVerifyEnabled}
                  >
                    Verify Email OTP
                  </button>
                </div>
              )}
            </div>
          ) : (
            // Empty div - the registration form will be shown below
            <div></div>
          )
        )}
      </div>
    ) : (
                  <div>
                    {userType === "lender" ? (
                      <form onSubmit={handleLenderRegistration}>
                        {step === 1 && (
                          <div>
                            <h4
                              style={{
                                color: "#ee373b",
                                textDecoration: "underline",
                                fontWeight: "bold",
                              }}
                            >
                              Basic Details
                            </h4>

                            <div className="form-group mb-3">
                              <label htmlFor="zone">Zone*</label>
                              <select
                                className="form-control"
                                id="zone"
                                value={selectedZone || ""}
                                onChange={(e) =>
                                  setSelectedZone(Number(e.target.value))
                                }
                                required
                              >
                                <option value="">Select Zone</option>
                                {zones.map((zone) => (
                                  <option key={zone.zoneId} value={zone.zoneId}>
                                    {zone.zoneDescription}
                                  </option>
                                ))}
                              </select>
                              {validationErrors.zone && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.zone}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="region">Region*</label>
                              <select
                                className="form-control"
                                id="region"
                                value={selectedRegionId || ""}
                                onChange={(e) => {
                                  const selectedRegion = regions.find(
                                    (r) => r.regionId === Number(e.target.value)
                                  );
                                  setSelectedRegionId(Number(e.target.value));
                                  setRegion(
                                    selectedRegion?.regionDescription || ""
                                  );
                                }}
                                disabled={!selectedZone}
                                required
                              >
                                <option value="">Select Region</option>
                                {regions.map((region) => (
                                  <option
                                    key={region.regionId}
                                    value={region.regionId}
                                  >
                                    {region.regionDescription}
                                  </option>
                                ))}
                              </select>
                              {validationErrors.region && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.region}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="branch">Branch*</label>
                              <input
                                type="text"
                                className="form-control"
                                id="branch"
                                placeholder="Enter Branch"
                                style={{
                                  maxWidth: "unset",
                                }}
                                value={branch}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setBranch,
                                    "branch",
                                    e.target.value,
                                    (value) => validateRequired(value, "Branch")
                                  )
                                }
                                required
                              />
                              {validationErrors.branch && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.branch}
                                </div>
                              )}
                            </div>
                            <button
                              type="button"
                              className="btn btn-danger btn-block w-100"
                              onClick={nextStep}
                            >
                              Next
                            </button>
                          </div>
                        )}
                        {step === 2 && (
                          <div>
                            <h4
                              style={{
                                color: "#ee373b",
                                textDecoration: "underline",
                                fontWeight: "bold",
                              }}
                            >
                              Primary Contact Details
                            </h4>
                            <div className="form-group mb-3">
                              <label htmlFor="mobileNumber">
                                Mobile Number*
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="mobileNumber"
                                placeholder="Enter your Mobile Number"
                                value={mobileNumber}
                                disabled={true}
                                maxLength="10"
                                required
                              />
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="email">Email*</label>
                              <input
                                type="email"
                                className="form-control"
                                id="email"
                                placeholder="Enter Email"
                                value={email}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setEmail,
                                    "email",
                                    e.target.value,
                                    validateEmail
                                  )
                                }
                                required
                              />
                              {validationErrors.email && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.email}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="managerName">Manager Name*</label>
                              <input
                                type="text"
                                className="form-control"
                                id="managerName"
                                placeholder="Enter Manager Name"
                                style={{
                                  maxWidth: "unset",
                                }}
                                value={managerName}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setManagerName,
                                    "managerName",
                                    e.target.value,
                                    (value) =>
                                      validateRequired(value, "Manager Name")
                                  )
                                }
                                required
                              />
                              {validationErrors.managerName && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.managerName}
                                </div>
                              )}
                            </div>
                            <button
                              type="button"
                              className="btn btn-secondary btn-block w-100"
                              onClick={prevStep}
                            >
                              Previous
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger btn-block w-100"
                              onClick={nextStep}
                            >
                              Next
                            </button>
                          </div>
                        )}
                        {step === 3 && (
                          <div>
                            <h4
                              style={{
                                color: "#ee373b",
                                textDecoration: "underline",
                                fontWeight: "bold",
                              }}
                            >
                              Point of Contact Details
                            </h4>
                            <div className="form-group mb-3">
                              <label htmlFor="pocName">
                                Point of Contact Name*
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="pocName"
                                placeholder="Enter Point of Contact Name"
                                value={pocName}
                                style={{
                                  maxWidth: "unset",
                                }}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setPocName,
                                    "pocName",
                                    e.target.value,
                                    (value) =>
                                      validateRequired(
                                        value,
                                        "Point of Contact Name"
                                      )
                                  )
                                }
                                required
                              />
                              {validationErrors.pocName && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.pocName}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="lenderPocNumber">
                                Point of Contact Number*
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="lenderPocNumber"
                                placeholder="Enter Point of Contact Number"
                                value={lenderPocNumber}
                                style={{
                                  maxWidth: "unset",
                                }}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setLenderPocNumber,
                                    "lenderPocNumber",
                                    e.target.value
                                      .replace(/\D/g, "")
                                      .slice(0, 10),
                                    validateMobile
                                  )
                                }
                                maxLength="10"
                                required
                              />
                              {validationErrors.lenderPocNumber && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.lenderPocNumber}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="lenderPocEmail">
                                Point of Contact Email*
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                id="lenderPocEmail"
                                placeholder="Enter Point of Contact Email"
                                value={lenderPocEmail}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setLenderPocEmail,
                                    "lenderPocEmail",
                                    e.target.value,
                                    validateEmail
                                  )
                                }
                                required
                              />
                              {validationErrors.lenderPocEmail && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.lenderPocEmail}
                                </div>
                              )}
                            </div>
                            <button
                              type="button"
                              className="btn btn-secondary btn-block w-100"
                              onClick={prevStep}
                            >
                              Previous
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger btn-block w-100"
                              onClick={nextStep}
                            >
                              Next
                            </button>
                          </div>
                        )}
                        {step === 4 && (
                          <div>
                            <h4
                              style={{
                                color: "#ee373b",
                                textDecoration: "underline",
                                fontWeight: "bold",
                              }}
                            >
                              Location Details
                            </h4>
                            <div className="form-group mb-3">
                              <label htmlFor="lenderCity">Bank Location*</label>
                              <select
                                className="form-control"
                                id="lenderCity"
                                value={lenderCity}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setLenderCity,
                                    "lenderCity",
                                    e.target.value,
                                    (value) =>
                                      validateRequired(value, "Bank Location")
                                  )
                                }
                                required
                              >
                                <option value="">Select Bank Location</option>
                                {[
                                  "Mumbai",
                                  "Delhi",
                                  "Bangalore",
                                  "Hyderabad",
                                  "Chennai",
                                  "Kolkata",
                                  "Pune",
                                  "Ahmedabad",
                                  "Jaipur",
                                  "Lucknow",
                                ].map((city) => (
                                  <option key={city} value={city}>
                                    {city}
                                  </option>
                                ))}
                              </select>
                              {validationErrors.lenderCity && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.lenderCity}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="state">State*</label>
                              <select
                                className="form-control"
                                id="state"
                                value={state}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setState,
                                    "state",
                                    e.target.value,
                                    (value) => validateRequired(value, "State")
                                  )
                                }
                                required
                              >
                                <option value="">Select State</option>
                                {[
                                  "Andhra Pradesh",
                                  "Arunachal Pradesh",
                                  "Assam",
                                  "Bihar",
                                  "Chhattisgarh",
                                  "Goa",
                                  "Gujarat",
                                  "Haryana",
                                  "Himachal Pradesh",
                                  "Jharkhand",
                                  "Karnataka",
                                  "Kerala",
                                  "Madhya Pradesh",
                                  "Maharashtra",
                                  "Manipur",
                                  "Meghalaya",
                                  "Mizoram",
                                  "Nagaland",
                                  "Odisha",
                                  "Punjab",
                                  "Rajasthan",
                                  "Sikkim",
                                  "Tamil Nadu",
                                  "Telangana",
                                  "Tripura",
                                  "Uttar Pradesh",
                                  "Uttarakhand",
                                  "West Bengal",
                                ].map((stateOption) => (
                                  <option key={stateOption} value={stateOption}>
                                    {stateOption}
                                  </option>
                                ))}
                              </select>
                              {validationErrors.state && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.state}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="address">Address*</label>
                              <textarea
                                className="form-control"
                                id="address"
                                placeholder="Enter Address"
                                value={address}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setAddress,
                                    "address",
                                    e.target.value,
                                    (value) =>
                                      validateRequired(value, "Address")
                                  )
                                }
                                required
                              />
                              {validationErrors.address && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.address}
                                </div>
                              )}
                            </div>
                            <button
                              type="button"
                              className="btn btn-secondary btn-block w-100"
                              onClick={prevStep}
                            >
                              Previous
                            </button>
                            {/* <button
                              type="button"
                              className="btn btn-danger btn-block w-100"
                              onClick={nextStep}
                            >
                              Next
                            </button> */}
                            <button
                              type="submit"
                              className="btn btn-danger btn-block w-100"
                            >
                              Register
                            </button>
                          </div>
                        )}
                        {step === 5 && (
                          <div>
                            <h4
                              style={{
                                color: "#ee373b",
                                textDecoration: "underline",
                                fontWeight: "bold",
                              }}
                            >
                              Financial Details
                            </h4>
                            <div className="form-group mb-3">
                              <label htmlFor="lenderGstNumber">
                                GST Number*
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="lenderGstNumber"
                                placeholder="Enter GST Number"
                                value={lenderGstNumber}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setLenderGstNumber,
                                    "lenderGstNumber",
                                    e.target.value.toUpperCase(),
                                    validateGST
                                  )
                                }
                                required
                              />
                              {validationErrors.lenderGstNumber && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.lenderGstNumber}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="lenderPanNumber">
                                PAN Number*
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="lenderPanNumber"
                                placeholder="Enter PAN Number"
                                value={lenderPanNumber}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setLenderPanNumber,
                                    "lenderPanNumber",
                                    e.target.value.toUpperCase(),
                                    validatePAN
                                  )
                                }
                                maxLength="10"
                                required
                              />
                              {validationErrors.lenderPanNumber && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.lenderPanNumber}
                                </div>
                              )}
                            </div>
                            <button
                              type="button"
                              className="btn btn-secondary btn-block w-100"
                              onClick={prevStep}
                            >
                              Previous
                            </button>
                            <button
                              type="submit"
                              className="btn btn-danger btn-block w-100"
                            >
                              Register
                            </button>
                          </div>
                        )}
                      </form>
                    ) : (
                      <form onSubmit={handleVendorRegistration}>
                        {vendorStep === 1 && (
                          <div>
                            <h4
                              style={{
                                color: "#ee373b",
                                textDecoration: "underline",
                                fontWeight: "bold",
                              }}
                            >
                              Basic Details
                            </h4>
                            <div className="form-group mb-3">
                              <label htmlFor="dealerName">Dealer Name*</label>
                              <input
                                type="text"
                                className="form-control"
                                id="dealerName"
                                placeholder="Enter Dealer Name"
                                value={dealerName}
                                style={{
                                  maxWidth: "unset",
                                }}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setDealerName,
                                    "dealerName",
                                    e.target.value,
                                    (value) =>
                                      validateRequired(value, "Dealer Name")
                                  )
                                }
                                required
                              />
                              {validationErrors.dealerName && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.dealerName}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="location">Location*</label>
                              <select
                                className="form-control"
                                id="location"
                                value={location}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setLocation,
                                    "location",
                                    e.target.value,
                                    (value) =>
                                      validateRequired(value, "Location")
                                  )
                                }
                                required
                              >
                                <option value="">Select Location</option>
                                {[
                                  "Mumbai",
                                  "Delhi",
                                  "Bangalore",
                                  "Hyderabad",
                                  "Chennai",
                                  "Kolkata",
                                  "Pune",
                                  "Ahmedabad",
                                  "Jaipur",
                                  "Lucknow",
                                ].map((loc) => (
                                  <option key={loc} value={loc}>
                                    {loc}
                                  </option>
                                ))}
                              </select>
                              {validationErrors.location && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.location}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="vendorManagerName">
                                Manager Name*
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="vendorManagerName"
                                placeholder="Enter Manager Name"
                                value={vendorManagerName}
                                style={{
                                  maxWidth: "unset",
                                }}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setVendorManagerName,
                                    "vendorManagerName",
                                    e.target.value,
                                    (value) =>
                                      validateRequired(value, "Manager Name")
                                  )
                                }
                                required
                              />
                              {validationErrors.vendorManagerName && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.vendorManagerName}
                                </div>
                              )}
                            </div>
                            <button
                              type="button"
                              className="btn btn-danger btn-block w-100"
                              onClick={nextStep}
                            >
                              Next
                            </button>
                          </div>
                        )}
                        {vendorStep === 2 && (
                          <div>
                            <h4
                              style={{
                                color: "#ee373b",
                                textDecoration: "underline",
                                fontWeight: "bold",
                              }}
                            >
                              Contact Details
                            </h4>
                            <div className="form-group mb-3">
                              <label htmlFor="mobileNumber">
                                Mobile Number*
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="mobileNumber"
                                placeholder="Enter your Mobile Number"
                                value={mobileNumber}
                                disabled={true}
                                maxLength="10"
                                required
                              />
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="vendorEmail">Email ID*</label>
                              <input
                                type="email"
                                className="form-control"
                                id="vendorEmail"
                                placeholder="Enter Email"
                                value={vendorEmail}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setVendorEmail,
                                    "vendorEmail",
                                    e.target.value,
                                    validateEmail
                                  )
                                }
                                required
                              />
                              {validationErrors.vendorEmail && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.vendorEmail}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="vendorPocName">
                                Point of Contact Name*
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="vendorPocName"
                                placeholder="Enter Point of Contact Name"
                                value={vendorPocName}
                                style={{
                                  maxWidth: "unset",
                                }}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setVendorPocName,
                                    "vendorPocName",
                                    e.target.value,
                                    (value) =>
                                      validateRequired(
                                        value,
                                        "Point of Contact Name"
                                      )
                                  )
                                }
                                required
                              />
                              {validationErrors.vendorPocName && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.vendorPocName}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="vendorPocNumber">
                                Point of Contact Number*
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="vendorPocNumber"
                                placeholder="Enter Point of Contact Number"
                                value={vendorPocNumber}
                                style={{
                                  maxWidth: "unset",
                                }}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setVendorPocNumber,
                                    "vendorPocNumber",
                                    e.target.value
                                      .replace(/\D/g, "")
                                      .slice(0, 10),
                                    validateMobile
                                  )
                                }
                                maxLength="10"
                                required
                              />
                              {validationErrors.vendorPocNumber && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.vendorPocNumber}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="vendorPocEmail">
                                Point of Contact Email*
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                id="vendorPocEmail"
                                placeholder="Enter Point of Contact Email"
                                value={vendorPocEmail}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setVendorPocEmail,
                                    "vendorPocEmail",
                                    e.target.value,
                                    validateEmail
                                  )
                                }
                                required
                              />
                              {validationErrors.vendorPocEmail && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.vendorPocEmail}
                                </div>
                              )}
                            </div>
                            <button
                              type="button"
                              className="btn btn-secondary btn-block w-100"
                              onClick={prevStep}
                            >
                              Previous
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger btn-block w-100"
                              onClick={nextStep}
                            >
                              Next
                            </button>
                          </div>
                        )}
                        {vendorStep === 3 && (
                          <div>
                            <h4
                              style={{
                                color: "#ee373b",
                                textDecoration: "underline",
                                fontWeight: "bold",
                              }}
                            >
                              Advanced Details
                            </h4>
                            <div className="form-group mb-3">
                              <label htmlFor="gstNumber">GST Number*</label>
                              <input
                                type="text"
                                className="form-control"
                                id="gstNumber"
                                placeholder="Enter GST Number"
                                value={gstNumber}
                                style={{
                                  maxWidth: "unset",
                                }}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setGstNumber,
                                    "gstNumber",
                                    e.target.value.toUpperCase(),
                                    validateGST
                                  )
                                }
                                required
                              />
                              {validationErrors.gstNumber && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.gstNumber}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="panNumber">PAN Number*</label>
                              <input
                                type="text"
                                className="form-control"
                                id="panNumber"
                                placeholder="Enter PAN Number"
                                value={panNumber}
                                style={{
                                  maxWidth: "unset",
                                }}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setPanNumber,
                                    "panNumber",
                                    e.target.value.toUpperCase(),
                                    validatePAN
                                  )
                                }
                                maxLength="10"
                                required
                              />
                              {validationErrors.panNumber && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.panNumber}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="accountNumber">
                                Bank Account Number*
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="accountNumber"
                                placeholder="Enter Bank Account Number"
                                value={accountNumber}
                                style={{
                                  maxWidth: "unset",
                                }}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setAccountNumber,
                                    "accountNumber",
                                    e.target.value.replace(/\D/g, ""),
                                    validateAccountNumber
                                  )
                                }
                                required
                              />
                              {validationErrors.accountNumber && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.accountNumber}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3">
                              <label htmlFor="ifscCode">IFSC Code*</label>
                              <input
                                type="text"
                                className="form-control"
                                id="ifscCode"
                                placeholder="Enter IFSC Code"
                                value={ifscCode}
                                style={{
                                  maxWidth: "unset",
                                }}
                                onChange={(e) =>
                                  handleFieldChange(
                                    setIfscCode,
                                    "ifscCode",
                                    e.target.value.toUpperCase(),
                                    validateIFSC
                                  )
                                }
                                maxLength="11"
                                required
                              />
                              {validationErrors.ifscCode && (
                                <div
                                  className="text-danger mt-1 bg-white"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {validationErrors.ifscCode}
                                </div>
                              )}
                            </div>
                            <button
                              type="button"
                              className="btn btn-secondary btn-block w-100"
                              onClick={prevStep}
                            >
                              Previous
                            </button>
                            <button
                              type="submit"
                              className="btn btn-danger btn-block w-100"
                            >
                              Register
                            </button>
                          </div>
                        )}
                      </form>
                    )}
                  </div>
                )}
                <p className="mt-3 text-center">
                  Already have an account?{" "}
                  <a href="#!" style={{ color: "#ee373b" }} onClick={(e) => { e.preventDefault(); toggleView(); }}>
                    Login
                  </a>
                </p>
                {userType === "lender" && (
                  <p className="mt-3 text-center">
                    Want to Onboard?{" "}
                    <a
                      style={{ color: "#ee373b" }}
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        nav("/masterLogin");
                      }}
                    >
                      Onboard
                    </a>
                  </p>
                )}
              </div>
            )}
            <InformationModal
              isOpen={isModalOpen}
              onClose={() => {
                setIsModalOpen(false);
                setModalMessage("");
                if (isRegisterVerifyEnabled && isOTPVerified) {
                  setIsLogin(true);
                }
              }}
              message={modalMessage}
            />
            {showAgreementModal && (
              <PopupModal
                onClose={handleAgreementCancel}
                onAgree={handleAgreementAgree}
                policies={policies}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CombinedLoginRegister;
